import { IconTokens, StepperStateToken } from '@voltmoney/schema';
import SharedPropsService from '../SharedPropsService';
import sharedPropsService, { BUILD_TYPE, getBuildType } from '../SharedPropsService';
import { ROUTE } from '../routes';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { api, config, partnerApi, StoreKey } from './api';
import CryptoJS from 'react-native-crypto-js';
import RazorpayCheckout from 'react-native-razorpay';
import { AssetRepositoryMap, AssetRepositoryType, CreditApplicationType, decrypt, encrypt, getAppHeader, initializeFirebase, isEncrypted, } from './config';
import { OpenNewTabTargetType, } from '@voltmoney/types';
import { AMPLITUDE_EVENT_PROPERTY, APPLICATION_STATE, CreditApplicationStepId, LENDER_ID, LOAN_RENEWAL_FLOW_SHOW, PartnerAccountType, PLATFORM_CODE, QUERY_PARAMS, ROUTE_PARTNER, TARGET_PAGES, UTM_expiry_days, VoltWebSiteBaseLink } from './constants';
import { getContactNumberForCall, getContactNumberForWhatsapp, getPlatformName, isGoogleLoginEnabled } from './uri-config-utils';
import { Platform, Share } from 'react-native';
import { ROUTE_PLATFORM } from "../platformDashboard/dashboard/utils";
import moment from "moment";
export const SDK_INVESTWELL = 'SDK_INVESTWELL';
export const FREO = 'FREO';
export const showBottomSheet = ({ title = 'Verification Failed!', subTitle, message, iconName, ctaAction, ctaLabel, primary, }) => {
    return {
        routeId: ROUTE.ALERT_PAGE,
        params: {
            alertProps: {
                title,
                subTitle,
                message,
                iconName,
                ctaAction,
                ctaLabel,
                primary,
            },
        },
    };
};
export const phonePayRoutes = [ROUTE.EMAIL_VERIFY, ROUTE.PAN_CONFIRM_NAME, ROUTE.MF_FETCH_PORTFOLIO, ROUTE.MF_PLEDGE_PORTFOLIO, ROUTE.SET_CREDIT_LIMIT, ROUTE.CHECKING_LIMIT, ROUTE.KYC_PAN_VERIFICATION];
export const getBankIconUrl = bankCode => `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/${bankCode}.svg`;
export const getBankPNGUrl = bankCode => `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode}.png`;
export const getBankDefaultPng = () => `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/default.png`;
export const updateStepStatusMap = async (stepStatusMap) => {
    const user = await SharedPropsService.getUser();
    user.linkedApplications[0].stepStatusMap = stepStatusMap;
    await SharedPropsService.setUser(user);
};
export const updateCurrentStepId = async (currentStepId) => {
    const user = await SharedPropsService.getUser();
    user.linkedApplications[0].currentStepId = currentStepId;
    await SharedPropsService.setUser(user);
};
export const getUpdatedApplicationDetails = async () => {
    const applicationId = await getApplicationId();
    const requestOptions = {
        method: "GET",
        headers: await getAppHeader(),
    };
    return await fetch(`${api.borrowerApplication}${applicationId}`, requestOptions).then(response => response.json())
        .catch(err => {
        console.log("err: ", err);
    });
};
export const navigateByCurrentStepId = (currentStepId) => {
    switch (currentStepId) {
        case StepperStateToken.PENDING_MANUAL_VERIFICATION:
            return {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                params: { applicationState: APPLICATION_STATE.BLOCKED }
            };
        case StepperStateToken.FAILED:
            return {
                routeId: ROUTE.FAILED_SCREEN,
                params: {}
            };
        case StepperStateToken.PENDING_VERIFICATION:
            return {
                routeId: ROUTE.NAME_MISMATCH,
                params: {
                    shouldCallMismatchApi: true
                }
            };
    }
    return undefined;
};
export const CREDIT_APPROVAL = "CREDIT_APPROVAL";
const clearLocalStorage = () => {
    const keysToKeep = ['first_time', 'show_new_arch', 'remoteConfig']; // Replace with your keys
    // Loop through all items in localStorage
    for (let i = 0; i < window?.localStorage?.length; i++) {
        const key = window?.localStorage?.key(i);
        if (!keysToKeep.includes(key)) {
            window?.localStorage?.removeItem(key);
        }
    }
};
/*** don't call this  ****/
export const clearAllData = async () => {
    window.sessionStorage?.clear();
    // window.localStorage?.clear()
    await SharedPropsService.clearGlobalPropstoken();
    await AsyncStorage?.removeItem(StoreKey.isPledgeFirstTime);
    await AsyncStorage?.removeItem(StoreKey.accessToken);
    await AsyncStorage?.removeItem("application_id");
    await AsyncStorage.removeItem("biometric_permission");
    await AsyncStorage.removeItem("applicationState");
    await SharedPropsService.setBorrowerUserProfile(undefined);
    if (Platform.OS === 'web') {
        if (window.location.protocol === 'https:') {
            document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; Secure;';
        }
        else {
            document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;Max-Age=-1;';
        }
        clearLocalStorage();
    }
    // await AsyncStorage.getAllKeys()
    //   .then((keys) => AsyncStorage.multiRemove(keys))
    //   .then(() => console.warn("Clear data"));
};
export const stepperRepo = async () => {
    let KYC_VERIFICATION;
    const message = 'We’re processing. Check after sometime.';
    const user = await SharedPropsService.getUser();
    const application = user.linkedApplications[0];
    if ((application.stepStatusMap.KYC_SUMMARY === undefined &&
        application.stepStatusMap.KYC_ADDITIONAL_DETAILS === undefined) ||
        (application.stepStatusMap.KYC_SUMMARY ===
            StepperStateToken.COMPLETED &&
            application.stepStatusMap.KYC_ADDITIONAL_DETAILS ===
                StepperStateToken.COMPLETED)) {
        KYC_VERIFICATION = StepperStateToken.COMPLETED;
    }
    else if (application.stepStatusMap.KYC_CKYC === StepperStateToken.NOT_STARTED) {
        KYC_VERIFICATION = StepperStateToken.NOT_STARTED;
    }
    else if (application.stepStatusMap.KYC_AADHAAR_VERIFICATION ===
        StepperStateToken.PENDING_MANUAL_VERIFICATION ||
        application.stepStatusMap.KYC_CKYC ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION ||
        application.stepStatusMap.KYC_SUMMARY ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION ||
        application.stepStatusMap.KYC_ADDITIONAL_DETAILS ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION ||
        application.stepStatusMap.KYC_DOCUMENT_UPLOAD ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION) {
        KYC_VERIFICATION = StepperStateToken.PENDING_MANUAL_VERIFICATION;
    }
    else {
        KYC_VERIFICATION = StepperStateToken.IN_PROGRESS;
    }
    const data = [
        {
            id: 'bd7acbea-c1b1-46c2-aed5-3ad53abb28ba',
            step: '1',
            title: 'KYC Verification',
            subTitle: 'Verify Aadhaar & other details to complete KYC',
            horizontalTitle: 'KYC',
            status: KYC_VERIFICATION,
            message: KYC_VERIFICATION ===
                StepperStateToken.PENDING_MANUAL_VERIFICATION
                ? message
                : '',
        },
        {
            id: '3ac68afc-c605-48d3-a4f8-fbd91aa97f63',
            step: '2',
            title: 'Setup bank and autopay ',
            subTitle: 'Provide bank account for receiving money',
            horizontalTitle: 'Bank account',
            status: application.stepStatusMap.BANK_ACCOUNT_VERIFICATION ||
                StepperStateToken.COMPLETED,
            message: application.stepStatusMap.BANK_ACCOUNT_VERIFICATION ===
                StepperStateToken.PENDING_MANUAL_VERIFICATION
                ? message
                : '',
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d74',
            step: '3',
            title: 'Sign loan agreement',
            subTitle: 'Link your account for hassle-free repayments',
            horizontalTitle: 'Agreement',
            status: application.stepStatusMap.AGREEMENT_SIGN,
            message: application.stepStatusMap.AGREEMENT_SIGN ===
                StepperStateToken.PENDING_MANUAL_VERIFICATION
                ? message
                : '',
        },
        {
            id: '58694a0f-3da1-471f-bd96-145571e29d72',
            step: '4',
            title: 'Setup AutoPay',
            subTitle: 'Link your account for hassle-free repayments',
            horizontalTitle: 'AutoPay',
            status: application.stepStatusMap.MANDATE_SETUP,
            message: application.stepStatusMap.MANDATE_SETUP ===
                StepperStateToken.PENDING_MANUAL_VERIFICATION
                ? message
                : '',
        },
    ];
    return data;
};
export const horizontalStepperRepo = async (network) => {
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const stepperResponse = await network.post(`${api.getStepper}`, {
        applicationId: applicationId,
    }, { headers: await getAppHeader() });
    return stepperResponse.data.borrowerViewStepperMap;
};
export const getCoBorrowerName = (coBorrowerId, coBorrowerMetadata) => {
    if (coBorrowerMetadata?.length !== null) {
        for (let i = 0; i < coBorrowerMetadata?.length; i++) {
            if (coBorrowerMetadata[i].coBorrowerAccountId === coBorrowerId) {
                return coBorrowerMetadata[i].coBorrowerName;
            }
        }
    }
};
export const doesContainNonSIPortfolioHolding = (portfolioList) => {
    for (let i = 0; i < portfolioList.length; i++) {
        if (portfolioList[i].modeOfHolding &&
            portfolioList[i].modeOfHolding !== 'SI' &&
            portfolioList[i].modeOfHolding !== '1' &&
            portfolioList[i].pledgedUnits > 0) {
            return true;
        }
    }
    return false;
};
// distributor Stepper
export const distributorStepperRepo = async () => {
    let DISTRIBUTOR_VERIFICATION;
    const message = 'We’re processing. Check after sometime.';
    const distributorData = [
        {
            id: '1',
            step: '1',
            title: 'Basic details',
            subTitle: 'Some description around basic details',
            horizontalTitle: 'Basic details',
            status: DISTRIBUTOR_VERIFICATION,
            message: DISTRIBUTOR_VERIFICATION ===
                StepperStateToken.PENDING_MANUAL_VERIFICATION
                ? message
                : '',
        },
        {
            id: '2',
            step: '2',
            title: 'Bank details',
            subTitle: 'Some description around basic details',
            horizontalTitle: 'Bank details',
            status: StepperStateToken.PENDING_MANUAL_VERIFICATION,
        },
        {
            id: '3',
            step: '3',
            title: 'Fetch portfolio',
            subTitle: 'Some description around basic details',
            horizontalTitle: 'Fetch portfolio',
            status: StepperStateToken.PENDING_MANUAL_VERIFICATION,
        },
        {
            id: '4',
            step: '4',
            title: 'Select Portfolio',
            subTitle: 'Some description around basic details',
            horizontalTitle: 'Select Portfolio',
            status: StepperStateToken.PENDING_MANUAL_VERIFICATION,
        },
    ];
};
export const horizontalDistributorStepperRepo = distributorStepperRepo;
export const nextStepCredStepper = async (currentStepId, stepMap) => {
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    if (!currentStepId) {
        currentStepId = user.linkedApplications[0].currentStepId;
    }
    let stepStatusMap;
    if (stepMap) {
        stepStatusMap = stepMap;
    }
    else {
        stepStatusMap = user.linkedApplications[0].stepStatusMap;
    }
    switch (user.linkedApplications[0].applicationState) {
        case APPLICATION_STATE.BLOCKED:
            return {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                params: { applicationState: APPLICATION_STATE.BLOCKED }
            };
            break;
        case APPLICATION_STATE.DENIED:
            return {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                params: { applicationState: APPLICATION_STATE.DENIED }
            };
            break;
    }
    if (stepStatusMap.DOCUMENTS ===
        StepperStateToken.PENDING_MANUAL_VERIFICATION) {
        return {
            routeId: ROUTE.AS_ES_DOCUMENT_IN_REVIEW,
            params: {},
        };
    }
    else if (stepStatusMap.DOCUMENTS ===
        StepperStateToken.FAILED) {
        return {
            routeId: ROUTE.AS_ES_DOCUMENT_REJECTED,
            params: {},
        };
    }
    const routeObjByStepId = navigateByCurrentStepId(stepStatusMap[`${currentStepId}`]);
    if (routeObjByStepId) {
        return routeObjByStepId;
    }
    if (!user.linkedBorrowerAccounts[0].accountHolderEmail) {
        // ***  Comment Email Verify FLow since google login is not working ***//
        const enableGoogleLogin = isGoogleLoginEnabled(user);
        return {
            routeId: enableGoogleLogin
                ? ROUTE.EMAIL_VERIFY
                : ROUTE.ENTER_EMAIL,
            params: {
                applicationId: user.linkedBorrowerAccounts[0].accountId,
            },
        };
    }
    if (currentStepId === ROUTE.KYC_PAN_VERIFICATION) {
        return {
            routeId: ROUTE.KYC_PAN_VERIFICATION,
            params: {
                applicationId: user.linkedApplications[0].applicationId,
                targetRoute: ROUTE.MF_FETCH_PORTFOLIO,
            },
        };
    }
    else if (currentStepId === ROUTE.MF_FETCH_PORTFOLIO) {
        return {
            routeId: ROUTE.MF_FETCH_PORTFOLIO,
            params: {
                applicationId: user.linkedApplications[0].applicationId,
                email: user.linkedBorrowerAccounts[0].accountHolderEmail,
                panNumber: user.linkedBorrowerAccounts[0].accountHolderPAN,
                mobileNumber: user.linkedBorrowerAccounts[0].accountHolderPhoneNumber,
            },
        };
    }
    else if (currentStepId === CreditApplicationStepId.DOCUMENTS) {
        return { routeId: ROUTE.AS_ES_DOCUMENTS_LISTING, params: {} };
    }
    else if (currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
        const isPledgeFirstTime = await SharedPropsService.isPledgeFirstTime();
        if (isPledgeFirstTime) {
            return {
                routeId: ROUTE.CHECKING_LIMIT,
                params: {},
            };
        }
        else {
            if (stepStatusMap.MF_PLEDGE_PORTFOLIO ===
                StepperStateToken.IN_PROGRESS) {
                return {
                    routeId: ROUTE.PLEDGE_CONFIRMATION,
                    params: {},
                };
            }
            else {
                return {
                    routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                    params: {},
                };
            }
        }
    }
    else if (stepStatusMap.DOCUMENTS ===
        StepperStateToken.PENDING_MANUAL_VERIFICATION) {
        return {
            routeId: ROUTE.AS_ES_DOCUMENT_IN_REVIEW,
            params: {},
        };
    }
    else if (stepStatusMap.DOCUMENTS ===
        StepperStateToken.FAILED) {
        return {
            routeId: ROUTE.AS_ES_DOCUMENT_REJECTED,
            params: {},
        };
    }
    else if (currentStepId === ROUTE.CHECK_CUSTOMER_ELIGIBILITY) {
        return {
            routeId: ROUTE.CHECK_CUSTOMER_ELIGIBILITY,
            params: {},
        };
    }
    else if (currentStepId === ROUTE.CIBIL_CHECK_LOADING_SCREEN) {
        return {
            routeId: ROUTE.CIBIL_CHECK_LOADING_SCREEN,
            params: {},
        };
    }
    else if (currentStepId === CREDIT_APPROVAL && lenderId !== 'Bajaj') {
        return {
            routeId: ROUTE.CREDIT_LOADING_SCREEN,
            params: {},
        };
    }
    if (currentStepId === ROUTE.KYC_AADHAAR_VERIFICATION) {
        return { routeId: ROUTE.KYC_DIGILOCKER, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_PHOTO_VERIFICATION) {
        const routeObjByStepId = navigateByCurrentStepId(stepStatusMap[`${currentStepId}`]);
        if (routeObjByStepId) {
            return routeObjByStepId;
        }
        return { routeId: ROUTE.KYC_PHOTO_VERIFICATION, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_ADDITIONAL_DETAILS) {
        return { routeId: ROUTE.KYC_ADDITIONAL_DETAILS, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_DOCUMENT_UPLOAD_POA) {
        return { routeId: ROUTE.KYC_DOCUMENT_UPLOAD_POA, params: {} };
    }
    else if (currentStepId === "ASSET_PLEDGE") {
        return { routeId: ROUTE.ASSET_PLEDGE_V2, params: {} };
    }
    else if (currentStepId === ROUTE.DIGIO_MANDATE_SIGN) {
        return { routeId: ROUTE.DIGIO_MANDATE_SIGN, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_DOCUMENT_UPLOAD_POI) {
        return { routeId: ROUTE.KYC_DOCUMENT_UPLOAD_POI, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_DOCUMENT_UPLOAD) {
        return { routeId: ROUTE.KYC_DOCUMENT_UPLOAD, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_SUMMARY) {
        return { routeId: ROUTE.KYC_SUMMARY, params: {} };
    }
    else if (currentStepId === ROUTE.SIGN_DESK_ESIGN) {
        return { routeId: ROUTE.SIGN_DESK_ESIGN, params: {} };
    }
    else if (currentStepId === ROUTE.BANK_ACCOUNT_VERIFICATION) {
        const routeObjByStepId = navigateByCurrentStepId(stepStatusMap[`${currentStepId}`]);
        if (routeObjByStepId) {
            return routeObjByStepId;
        }
        return { routeId: ROUTE.BANK_ACCOUNT_VERIFICATION, params: {} };
    }
    else if (currentStepId === ROUTE.KYC_DIGILOCKER) {
        return { routeId: ROUTE.KYC_DIGILOCKER, params: {} };
    }
    else if (currentStepId === ROUTE.BAJAJ_KFS) {
        return { routeId: ROUTE.BAJAJ_KFS, params: {} };
    }
    else if (currentStepId === ROUTE.REVIEW_AGREEMENT_STEPPER) {
        return { routeId: ROUTE.REVIEW_AGREEMENT_STEPPER, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CO_BORROWER_PAN_DETAILS) {
        return { routeId: ROUTE.CO_BORROWER_LANDING, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CO_BORROWER_ADDITIONAL_DETAILS) {
        return { routeId: ROUTE.CO_BORROWER_ADDITIONAL_DETAILS, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CO_BORROWER_KYC_SUMMARY) {
        return { routeId: ROUTE.CO_BORROWER_SUMMARY, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.KYC_DOCUMENTS) {
        return { routeId: ROUTE.KYC_DOCUMENTS_DIGIO_BASE, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CO_BORROWER_KYC_DOCUMENTS) {
        return { routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE, params: {} };
    }
    else if (
    // currentStepId === CreditApplicationStepId.DIGIO_MANDATE_SIGN ||
    currentStepId === CreditApplicationStepId.CIBIL_CHECK) {
        //Make an API call to get stepper and find route and then proceed with next step id
        const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
        let raw = JSON.stringify({
            applicationId: applicationId,
        });
        const url = `${api.getStepper}`;
        if (isEncrypted(url)) {
            raw = JSON.stringify({ encryptedRequest: await encrypt(raw) });
        }
        const requestOptions = {
            method: 'POST',
            headers: await getAppHeader(),
            body: raw,
        };
        return await fetch(url, requestOptions)
            .then(response => response.json())
            .then(async (response) => {
            if (isEncrypted(url)) {
                console.log(response);
                response = JSON.parse(await decrypt(response.result));
            }
            return response;
        })
            .then(response => {
            console.warn("ROUTE FROM API", response?.routeModel);
            const routeModel = response?.routeModel;
            if (lenderId === "Bajaj" && response?.routeModel === CreditApplicationStepId.CREDIT_APPROVAL) {
                return { routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER, params: {} };
            }
            else {
                if (routeModel?.params) {
                    return { routeId: routeModel.routeId, params: routeModel.routeOptions };
                }
                else {
                    return { routeId: routeModel.routeId, params: {} };
                }
            }
        });
    }
    else if (currentStepId === CreditApplicationStepId.DIGIO_AGREEMENT_SIGN) {
        return { routeId: ROUTE.DIGIO_AGREEMENT_SIGN, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.REVIEW_KFS) {
        return { routeId: ROUTE.BAJAJ_AGREEMENT_STEPPER, params: {} };
    }
    else if (stepStatusMap.AGREEMENT_SIGN === StepperStateToken.NOT_STARTED) {
        return { routeId: ROUTE.LOAN_AGREEMENT_POLLING, params: {} };
    }
    else if (stepStatusMap.AGREEMENT_SIGN === StepperStateToken.IN_PROGRESS) {
        return { routeId: lenderId === 'Bajaj' ? ROUTE.BAJAJ_AGREEMENT_STEPPER : ROUTE.LOAN_AGREEMENT, params: {} };
    }
    else if (stepStatusMap.LOAN_CONTRACT === StepperStateToken.NOT_STARTED) {
        return { routeId: ROUTE.DSP_KFS, params: {} };
    }
    else if (stepStatusMap.LOAN_CONTRACT === StepperStateToken.IN_PROGRESS) {
        return { routeId: ROUTE.DSP_KFS, params: {} };
    }
    else if (stepStatusMap.MANDATE_SETUP === StepperStateToken.IN_PROGRESS) {
        return { routeId: ROUTE.LOAN_REPAYMENT, params: {} };
    }
    else if (stepStatusMap.MANDATE_SETUP === StepperStateToken.NOT_STARTED) {
        return { routeId: ROUTE.LOAN_AUTOPAY, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CHECK_CUSTOMER_ELIGIBILITY) {
        return { routeId: ROUTE.CHECK_CUSTOMER_ELIGIBILITY, params: {} };
    }
    else if (currentStepId === CreditApplicationStepId.CREDIT_APPROVAL) {
        if (lenderId !== 'Bajaj') {
            return { routeId: ROUTE.CREDIT_LOADING_SCREEN, params: {} };
        }
        else {
            return { routeId: ROUTE.LOAN_AGREEMENT_POLLING, params: {} };
        }
    }
    else if (currentStepId === CreditApplicationStepId.TATA_MANDATE) {
        return {
            routeId: ROUTE.DIGIO_MANDATE_SIGN, params: {
                isFromTata: true
            }
        };
    }
    else if (currentStepId === CreditApplicationStepId.OFFER_SELECTION) {
        return {
            routeId: ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE,
            params: {}
        };
    }
    else if (currentStepId === CreditApplicationStepId.DOCUMENTS) {
        return { routeId: ROUTE.AS_ES_DOCUMENTS_LISTING, params: {} };
    }
    if (user.linkedApplications[0].applicationState === "COMPLETED") {
        // -------------  LOAN RENEWAL FLOW -------------- //
        const params = Platform.OS === "web" && getParametersFromURL();
        if (!await sharedPropsService.getAllowHome() || params?.platform === "BHARAT_PE" || params?.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
            return {
                routeId: ROUTE.CREDIT_LOADING_SCREEN, params: { showDownloadAppScreen: true }
            };
        }
        const showLoanRenewalFlow = await LOAN_RENEWAL_FLOW_SHOW();
        if (showLoanRenewalFlow) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            const applicationDetail = await getUpdatedApplicationDetails();
            const applicationType = applicationDetail?.applicationType;
            const currentStepId = applicationDetail?.currentStepId;
            if (currentStepId === null &&
                applicationType === CreditApplicationType.CREDIT_RENEWAL_AGAINST_SECURITIES) {
                return {
                    routeId: ROUTE.LOAN_RENEWAL_STATUS_PAGE, params: {
                        hideGoBack: true
                    }
                };
            }
        }
        // -------------  LOAN RENEWAL FLOW -------------- //
        return {
            routeId: ROUTE.DASHBOARD, params: {}
        };
    }
};
export const nextStepId = async (currentStepId, start_page, statusMap) => {
    const user = await SharedPropsService.getUser();
    const stepStatusMap = user.linkedApplications[0].stepStatusMap;
    const lenderId = user?.linkedApplications[0]?.lenderAccountId;
    switch (user.linkedApplications[0].applicationState) {
        case APPLICATION_STATE.BLOCKED:
            return {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                params: { applicationState: APPLICATION_STATE.BLOCKED }
            };
            break;
        case APPLICATION_STATE.DENIED:
            return {
                routeId: ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN,
                params: { applicationState: APPLICATION_STATE.DENIED }
            };
            break;
        case APPLICATION_STATE.COMPLETED:
            return {
                routeId: ROUTE.DASHBOARD, params: {}
            };
            break;
    }
    const routeObjByStepId = navigateByCurrentStepId(stepStatusMap[`${currentStepId}`]);
    if (routeObjByStepId && currentStepId !== "DOCUMENTS") {
        return routeObjByStepId;
    }
    ///check if any application IN_PROGRESS
    if (currentStepId ||
        user.linkedApplications[0].applicationState === 'IN_PROGRESS') {
        if (stepStatusMap.DOCUMENTS ===
            StepperStateToken.PENDING_MANUAL_VERIFICATION) {
            return {
                routeId: ROUTE.AS_ES_DOCUMENT_IN_REVIEW,
                params: {},
            };
        }
        else if (stepStatusMap.DOCUMENTS ===
            StepperStateToken.FAILED) {
            return {
                routeId: ROUTE.AS_ES_DOCUMENT_REJECTED,
                params: {},
            };
        }
        else if (start_page === "Landing_Page") {
            start_page = "";
            return {
                routeId: ROUTE.BORROWER_LANDING_SCREEN,
                params: {
                    applicationId: user.linkedApplications[0].applicationId,
                    reFetch: true,
                },
            };
        }
        if (!user.linkedBorrowerAccounts[0].accountHolderEmail) {
            // ***  Comment Email Verify FLow since google login is not working ***//
            const enableGoogleLogin = isGoogleLoginEnabled(user);
            return {
                routeId: enableGoogleLogin
                    ? ROUTE.EMAIL_VERIFY
                    : ROUTE.ENTER_EMAIL,
                params: {
                    applicationId: user.linkedBorrowerAccounts[0].accountId,
                },
            };
        }
        if (currentStepId === ROUTE.KYC_PAN_VERIFICATION) {
            return {
                routeId: ROUTE.KYC_PAN_VERIFICATION,
                params: {
                    applicationId: user.linkedApplications[0].applicationId,
                    targetRoute: ROUTE.MF_FETCH_PORTFOLIO,
                },
            };
        }
        else if (currentStepId === ROUTE.MF_FETCH_PORTFOLIO) {
            return {
                routeId: ROUTE.MF_FETCH_PORTFOLIO,
                params: {
                    applicationId: user.linkedApplications[0].applicationId,
                    email: user.linkedBorrowerAccounts[0].accountHolderEmail,
                    panNumber: user.linkedBorrowerAccounts[0].accountHolderPAN,
                    mobileNumber: user.linkedBorrowerAccounts[0].accountHolderPhoneNumber,
                },
            };
        }
        else if (currentStepId === ROUTE.MF_PLEDGE_PORTFOLIO) {
            const isPledgeFirstTime = await SharedPropsService.isPledgeFirstTime();
            const shouldShowCheckingLimit = stepStatusMap?.MF_FETCH_PORTFOLIO === "COMPLETED";
            if (isPledgeFirstTime && !shouldShowCheckingLimit) {
                return {
                    routeId: ROUTE.CHECKING_LIMIT,
                    params: {},
                };
            }
            else {
                if (stepStatusMap.MF_PLEDGE_PORTFOLIO ===
                    StepperStateToken.IN_PROGRESS) {
                    return {
                        routeId: ROUTE.PLEDGE_CONFIRMATION,
                        params: {},
                    };
                }
                else {
                    return {
                        routeId: ROUTE.MF_PLEDGE_PORTFOLIO,
                        params: {},
                    };
                }
            }
        }
        else if (currentStepId === ROUTE.CHECK_CUSTOMER_ELIGIBILITY) {
            return {
                routeId: ROUTE.CHECK_CUSTOMER_ELIGIBILITY,
                params: {},
            };
        }
        else if (currentStepId === ROUTE.CIBIL_CHECK_LOADING_SCREEN) {
            return {
                routeId: ROUTE.CIBIL_CHECK_LOADING_SCREEN,
                params: {},
            };
        }
        else if (currentStepId === CREDIT_APPROVAL && lenderId !== 'Bajaj') {
            return {
                routeId: ROUTE.CREDIT_LOADING_SCREEN,
                params: {},
            };
        }
        else if (currentStepId === 'KYC_DOCUMENTS'
            || currentStepId === 'BANK_ACCOUNT_VERIFICATION'
            || currentStepId === 'KYC_PHOTO_VERIFICATION') {
            const routeObjByStepId = navigateByCurrentStepId(stepStatusMap[currentStepId]);
            if (routeObjByStepId) {
                return routeObjByStepId;
            }
            else {
                return { routeId: ROUTE.KYC_STEPPER, params: {} };
            }
        }
        else {
            return { routeId: ROUTE.KYC_STEPPER, params: {} };
        }
    }
};
export const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(async () => {
            return await callback.apply(null, args);
        }, wait);
    };
};
export const stopCamera = () => {
    const video = document.querySelector('video');
    const mediaStream = video.srcObject;
    if (mediaStream) {
        if ('getTracks' in mediaStream) {
            const tracks = mediaStream.getTracks();
            tracks[0].stop();
            tracks.forEach(track => track.stop());
        }
    }
};
export const maskSensitiveDetails = (str, start, end) => {
    // if length is 13 then start = 4 and end = 9
    let maskedString = '';
    const len = str.length;
    const iterate = len - end;
    const lastDigit = str.substring(iterate);
    for (let i = 0; i < iterate; i++) {
        maskedString += '*';
    }
    return maskedString + lastDigit;
};
export const maskBankSensitiveDetails = (str, start) => {
    let maskedString = '';
    for (let i = 0; i < str.length; i++) {
        if (i < start)
            maskedString += 'X';
        else
            maskedString += str[i];
    }
    return maskedString;
};
export const formatFullName = (fullName) => {
    const parts = fullName?.split(" ");
    const formattedParts = parts.map(part => {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
    const formattedFullName = formattedParts.join(" ");
    return formattedFullName;
};
export const maskString = (str, start, end) => {
    // if length is 13 then start = 4 and end = 9
    let maskedString = '';
    if (str.startsWith('+91')) {
        str = str.substring(3);
    }
    for (let i = 0; i < str.length; i++) {
        if (i >= start && i <= end) {
            maskedString += '*';
        }
        else {
            maskedString += str[i];
        }
    }
    return maskedString;
};
export const addCommasToNumber = (num) => {
    return num?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
};
export const roundDownToNearestHundred = (num) => {
    return Math.floor(num / 100) * 100;
};
export const ceilToNearestHundred = (num) => {
    return Math.ceil(num / 100) * 100;
};
export const maskBankAccountNumber = (accountNo) => {
    if (accountNo.length > 4) {
        const showString = accountNo.slice(accountNo.length - 4);
        let maskString = '';
        let index = accountNo.length - 4;
        while (index > 0) {
            maskString += 'X';
            index--;
        }
        return maskString.concat(showString);
    }
    return accountNo;
};
export const isMorePortfolioRenderCheck = async () => {
    const casList = await SharedPropsService.getCasListOriginal();
    /*** check if the user has pledged any mf portfolio */
    const assetRepoMap = {};
    /*** Get unique asset repository from the cas list */
    for (let i = 0; i < casList.length; i++) {
        const item = casList[i];
        assetRepoMap[item.assetRepository] = true;
    }
    /*** remove if both Karvy and Cams are present */
    return !(Object.keys(assetRepoMap).length === 2 ||
        (Object.keys(assetRepoMap).length == 1 &&
            (AssetRepositoryMap.get(AssetRepositoryType.CAMS).isDisabled ||
                AssetRepositoryMap.get(AssetRepositoryType.KARVY).isDisabled)));
};
export const getParametersFromURL = () => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    return getParameters(url);
};
export const getParameters = (url) => {
    if (url) {
        const params = {};
        const paramString = url.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        for (const pair of queryString.entries()) {
            params[pair[0].includes('/') ? pair[0].split('/')[1] : pair[0]] =
                pair[1].includes('/') ? pair[1].split('/')[0] : pair[1];
        }
        return params;
    }
    return {};
};
export const isLimitMoreThanPledgeThreshold = async () => {
    const pledgeThreshold = await SharedPropsService.getCreditLimit();
    if (pledgeThreshold > 25000) {
        return true;
    }
    else {
        return false;
    }
};
export const updateApplicationContextFromApi = async (network, applicationId, disableDefaultNetworkHandle = false) => {
    const user = await SharedPropsService.getUser();
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() }, async () => {
        return;
    }, disableDefaultNetworkHandle
        ? { disableDefault: disableDefaultNetworkHandle }
        : {});
    user.linkedApplications[0] = updatedApplicationResponse.data;
    await SharedPropsService.setUser(user);
};
export const updateUserContextFromApi = async (network) => {
    const user = await SharedPropsService.getUser();
    const onboardingPartnerCode = user.user.onboardingPartnerCode;
    const relationshipManagerCode = user.user.onboardingRelationshipManagerCode;
    const updateUserProfileResponse = await network.post(`${api.userContext}`, {
        onboardingPartnerCode: onboardingPartnerCode,
        relationshipManagerCode: relationshipManagerCode,
    }, { headers: await getAppHeader() });
    await SharedPropsService.setUser(updateUserProfileResponse.data);
};
export const removeCommasFromNumber = (num) => {
    return num.replace(/,/g, '');
};
export const isPopupBlocked = () => {
    const popup = window.open("", "_blank");
    if (popup === null || typeof popup === "undefined") {
        return true; // Popup blocked
    }
    popup.close();
    return false; // Popup not blocked
};
export const isIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
const appendParamsToUrl = (sourceUrl, targetUrl) => {
    // Parse the source and target URLs
    const source = new URL(sourceUrl);
    const target = new URL(targetUrl);
    // Get the search parameters from the source URL
    const sourceParams = new URLSearchParams(source.search);
    // Append each parameter to the target URL
    sourceParams.forEach((value, key) => {
        target.searchParams.append(key, value);
    });
    return target.toString();
};
export const getDigio = async (successCB, failureCB, origin) => {
    let primaryColor = undefined;
    let secondaryColor = undefined;
    let isFromJsSDK = false;
    let isFromPhonePe = false;
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0].lenderAccountId;
    let isFromRnSdk = false;
    let isFromRedVision = false;
    if (Platform.OS === 'web') {
        const url = window?.location?.href;
        const params = getParameters(url);
        if (getPlatformName(params).includes("PHONEPE" /* AppPlatform.PHONEPE */)) {
            isFromPhonePe = true;
        }
        if (getPlatformName(params).includes("REDVISION")) {
            isFromRedVision = true;
        }
        primaryColor = params?.primaryColor;
        secondaryColor = params?.secondaryColor;
        if (params?.isFromRnSdk) {
            isFromRnSdk = true;
        }
        if (params?.isFromJsSDK) {
            isFromJsSDK = true;
        }
    }
    const redirectionUrl = isFromRnSdk ? `${window.location.href}&kyc_response=digio` : `${config.APP_URL}/?kyc_response=digio`;
    let redirectUrl = isIframe() || (isFromAndroidWebview() && !isFromRedVision && !isFromPhonePe && !isFromRnSdk) || isFromJsSDK ? null : redirectionUrl;
    if (origin && redirectUrl) {
        redirectUrl += `&origin=${origin}`;
    }
    const digioOptions = {
        environment: config.DIGIO_ENVIRONMENT,
        callback: function (response) {
            if (response.hasOwnProperty('error_code')) {
                failureCB && failureCB(response);
                return console.log('error occurred in process =>', response);
            }
            successCB && successCB(response);
            console.log('Signing completed successfully');
        },
        theme: {
            primaryColor: primaryColor ? `#${primaryColor}` : '#234FDA',
            secondaryColor: secondaryColor ? `#${secondaryColor}` : '#234FDA',
        },
        logo: lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() && 'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/dsp_finance_logo.png',
        fontFamily: 'Poppins',
        fontUrl: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        is_iframe: (isFromAndroidWebview() && !isFromRnSdk && !isFromPhonePe && !isFromRedVision) ? true : false,
        is_redirection_approach: isIframe() || (isFromAndroidWebview() && !isFromRnSdk && !isFromPhonePe && !isFromRedVision) || isFromJsSDK ? false : true,
        redirect_url: redirectUrl,
    };
    //@ts-ignore
    const digioObj = new Digio(digioOptions);
    //@ts-ignore
    window.digio = digioObj;
};
export const getDigioForMandate = (successCB, failureCB, origin) => {
    let redirectUrl = isIframe() ? null : `${config.APP_URL}/?digio_agreement_response=digio`;
    if (origin && redirectUrl) {
        redirectUrl += `&origin=${origin}`;
    }
    const digioOptions = {
        environment: config.DIGIO_ENVIRONMENT,
        callback: function (response) {
            if (response.hasOwnProperty('error_code')) {
                failureCB && failureCB(response);
                return console.log('error occurred in process =>', response);
            }
            successCB && successCB(response);
            console.log('Signing completed successfully');
        },
        theme: {
            primaryColor: '#234FDA',
            secondaryColor: '#234FDA',
        },
        logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
        fontFamily: 'Poppins',
        fontUrl: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        is_iframe: isFromAndroidWebview() ? false : false,
        is_redirection_approach: isIframe() ? false : true,
        redirect_url: redirectUrl,
    };
    //@ts-ignore
    const digioObj = new Digio(digioOptions);
    //@ts-ignore
    window.digio = digioObj;
};
export const showEmail = (lenderId) => {
    return lenderId.toLowerCase() !== LENDER_ID.NUVAMA;
};
export const getDigioForAutoPay = (successCB, failureCB) => {
    const autoPayRedirectionURL = isIframe() && !isFromAndroidWebview() ? null : `${config.APP_URL}/?digio_autopay_response=digio`;
    const digioOptions = {
        environment: config.DIGIO_ENVIRONMENT,
        callback: function (response) {
            if (response.hasOwnProperty('error_code')) {
                failureCB && failureCB(response);
                return console.log('error occurred in process');
            }
            successCB && successCB(response);
            console.log('Signing completed successfully');
        },
        theme: {
            primaryColor: '#234FDA',
            secondaryColor: '#234FDA',
        },
        logo: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg',
        fontFamily: 'Poppins',
        fontUrl: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        is_iframe: isFromAndroidWebview() ? false : false,
        is_redirection_approach: isIframe() && !isFromAndroidWebview() ? false : true,
        redirect_url: autoPayRedirectionURL,
    };
    //@ts-ignore
    const digioObj = new Digio(digioOptions);
    //@ts-ignore
    window.digio = digioObj;
};
export function convertToKLacsCore(val, allowedDecimals = 0) {
    if (val >= 10000000)
        val = (val / 10000000).toFixed(allowedDecimals) + ' Cr';
    else if (val >= 100000)
        val = (val / 100000).toFixed(allowedDecimals) + ' Lac';
    else if (val >= 1000)
        val = (val / 1000).toFixed(allowedDecimals) + ' K';
    return val;
}
export const uploadToS3Bucket = function (url, uri, contentType, imageUri) {
    return new Promise(function (resolve, reject) {
        console.log('Url received', url);
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url);
        console.log('OPENED UPLOAD GATE', xhr.status);
        xhr.onprogress = function () {
            console.log('LOADING UPLOAD GATE', xhr.status);
        };
        xhr.onerror = function () {
            console.log('ERROR', xhr.status);
        };
        xhr.onload = function () {
            console.log('DONE', xhr.status);
        };
        xhr.setRequestHeader('Content-Type', contentType);
        xhr.send({ uri: imageUri ? imageUri : uri.uri, type: uri.type, name: uri.fileName ? uri.fileName : url.name });
        xhr.onreadystatechange = function () {
            console.log('Inside the upload trajectory', xhr.readyState);
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    resolve(true);
                }
                else {
                    reject(false);
                }
            }
            else {
                console.log('totally outside');
            }
        };
    });
};
export const uploadToS3BucketUpdate = function (url, uri, contentType, imageUri) {
    return new Promise((resolve, reject) => {
        console.log('URL received', url);
        const attemptUpload = async () => {
            try {
                const fileToUpload = {
                    uri: imageUri ? imageUri : uri.uri,
                    name: uri.fileName ? uri.fileName : (imageUri ? imageUri.split('/').pop() : uri.uri.split('/').pop()),
                    type: uri.type,
                };
                const response = await fetch(url, {
                    method: 'PUT',
                    //@ts-ignore
                    body: fileToUpload,
                    headers: {
                        'Content-Type': contentType,
                    },
                });
                console.log(response, "Upload response");
                if (response.ok) {
                    console.log('Upload successful', response.status);
                    resolve(true);
                }
                else {
                    console.error('Upload failed', response.status, response.statusText);
                    reject(false);
                }
            }
            catch (error) {
                console.error('Network error', error);
                reject(error);
            }
        };
        attemptUpload();
    });
};
export const getLimitIncreaseAvailable = (data) => {
    return Math.max(data?.credit?.availableCreditAmount -
        data?.credit?.approvedCreditAmount, 0).toString();
};
export const convertDateToISO = (dateString) => {
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
};
export const convertISOToTimestamp = (isoDateString) => {
    const timestamp = Date.parse(isoDateString);
    return timestamp; // Convert milliseconds to seconds
};
export const convertDateToTimeStamp = (dateString) => {
    // example date string
    const dateParts = dateString.split('-'); // split the date string into day, month, and year parts
    const dateObject = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`); // create a new Date object from the date parts in YYYY-MM-DD format
    const timestamp = dateObject.getTime();
    return timestamp;
};
export const addYearToEpochTime = (epochTime, year) => {
    const oneYearLater = new Date(epochTime * 1000); // Convert to Date object
    oneYearLater.setFullYear(oneYearLater.getFullYear() + year); // Add 1 year
    const oneYearLaterEpochTime = Math.floor(oneYearLater.getTime() / 1000); // Convert back to epoch time (seconds)
    console.log(oneYearLaterEpochTime); // Output: 1646832000 (March 9, 2022
    return oneYearLaterEpochTime;
};
export const addMinutesToCurrentTimeStamp = (minutes) => {
    // get the current date and time
    const currentDate = new Date();
    // add 3 minutes to the current time
    currentDate.setMinutes(currentDate.getMinutes() + minutes);
    // display the updated timestamp
    return currentDate.valueOf();
};
export const convert_DD_MM_YY_ToEpochTime = (dd_mm_yyyy) => {
    const dateParts = dd_mm_yyyy.split('-');
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Month value is 0-based in JavaScript
    const year = parseInt(dateParts[2], 10);
    // Create a date object in UTC time zone using the year, month, and day components
    const date = new Date(Date.UTC(year, month, day));
    // Get the epoch time value of the date object
    return date.getTime();
};
export const removeParamFromURL = (param, openNewTab) => {
    if (Platform.OS === 'web') {
        const url = window.location.href;
        const [path, searchParams] = url.split('?');
        const newSearchParams = searchParams
            ?.split('&')
            .filter(p => !(p.toLowerCase() === param.toLowerCase() ||
            p.toLowerCase().startsWith(`${param.toLowerCase()}=`)))
            .join('&');
        const result = newSearchParams ? `${path}?${newSearchParams}` : path;
        openNewTab(result, OpenNewTabTargetType.self);
    }
};
export const removeUrlWithoutReload = (param) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.pushState(null, '', url.toString());
};
export const addQueryParamsWithoutReload = (param, paramValue) => {
    const url = new URL(window.location.href);
    url.searchParams.append(param, paramValue);
    window.history.pushState(null, '', url.toString());
};
export const removePathFromUrlWithouReload = (param) => {
    const url = window.location.href;
    const newUrl = url.replace(param, '');
    window.history.replaceState(null, '', newUrl);
};
export const removeQueryFromUrlWithoutReloadV2 = (param) => {
    const url = new URL(window.location.href);
    // Remove the specified parameter
    url.searchParams.delete(param);
    // Update the URL without reloading
    window.history.replaceState(null, '', url.toString());
};
export function removeURLParams() {
    const url = window?.location?.protocol + "//" + window?.location?.host + window?.location?.pathname;
    window?.history?.replaceState({ path: url }, '', url);
}
export const isMobile = () => {
    const Breakpoint = 1024;
    if (Platform.OS === 'web') {
        if (window?.outerWidth < Breakpoint) {
            return true;
        }
        else {
            return false;
        }
    }
    return true;
};
export const getTargetParamFromURL = () => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = Platform.OS === 'web' ? getParameters(url) : {};
    return params?.target;
};
export const switchToSpecificRoutes = async (user, availableCreditAmount, navigate, isPendingDisbursal, showForeclosure, showNewForeClosure) => {
    const target = await AsyncStorage.getItem("target");
    console.warn("TARGET RECEIVED IS", target, availableCreditAmount, !isPendingDisbursal);
    if (target !== null) {
        switch (target) {
            case TARGET_PAGES.ACCOUNT:
                return navigate(ROUTE.MY_PROFILE);
            case TARGET_PAGES.WITHDRAW:
                return availableCreditAmount > 0 && !isPendingDisbursal
                    ? await navigate(ROUTE.WITHDRAW_AMOUNT, {
                        availableCreditAmount: availableCreditAmount
                    })
                    : await navigate(ROUTE.DASHBOARD);
            case TARGET_PAGES.REPAYMENT:
                return navigate(ROUTE.PAYMENT_START);
            case TARGET_PAGES.FORECLOSURE:
                return showNewForeClosure ? navigate(ROUTE.FORECLOSURE_NEW) : showForeclosure ? navigate(ROUTE.FORECLOSURE) : navigate(ROUTE.DASHBOARD);
            case TARGET_PAGES.MANAGE_LIMIT:
                return navigate(ROUTE.MANAGE_LIMIT);
            case TARGET_PAGES.TRANSACTION:
                return navigate(ROUTE.TRANSACTIONS);
            default:
                return navigate(ROUTE.DASHBOARD);
        }
    }
    else {
        switch (getTargetParamFromURL()) {
            case TARGET_PAGES.ACCOUNT:
                return navigate(ROUTE.MY_PROFILE, { target: TARGET_PAGES.ACCOUNT });
            case TARGET_PAGES.WITHDRAW:
                return availableCreditAmount > 0 && !isPendingDisbursal
                    ? await navigate(ROUTE.WITHDRAW_AMOUNT, {
                        target: TARGET_PAGES.WITHDRAW,
                        availableCreditAmount: availableCreditAmount
                    })
                    : await navigate(ROUTE.DASHBOARD);
            case TARGET_PAGES.REPAYMENT:
                return navigate(ROUTE.PAYMENT_START, { target: TARGET_PAGES.REPAYMENT });
            case TARGET_PAGES.FORECLOSURE:
                return showNewForeClosure ? navigate(ROUTE.FORECLOSURE_NEW, { target: TARGET_PAGES.FORECLOSURE }) : navigate(ROUTE.FORECLOSURE, { target: TARGET_PAGES.FORECLOSURE });
            case TARGET_PAGES.MANAGE_LIMIT:
                return navigate(ROUTE.MANAGE_LIMIT, {
                    target: TARGET_PAGES.MANAGE_LIMIT,
                });
            case TARGET_PAGES.TRANSACTION:
                return navigate(ROUTE.TRANSACTIONS, { target: TARGET_PAGES.TRANSACTION });
            default:
                return navigate(ROUTE.DASHBOARD, {
                    cacheUserContext: true
                });
        }
    }
};
export const isFromAndroidWebview = () => {
    const isWebView = navigator?.userAgent?.includes('wv');
    console.warn("IS FROM WEBVIEW", isWebView);
    return isWebView;
};
export const openAdvisorLinkWhatsApp = (interestRate, advisoryLink, name) => {
    if (Platform.OS === 'web') {
        window.open(`https://api.whatsapp.com//send?text=Greetings%20🙏%0a%0aHelp%20your%20clients%20meet%20short%20term%20cash%20needs%20without%20redeeming%20mutual%20funds%2e%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20empanel%20now%2e%0a${advisoryLink}%0a%0aRegards%2c%0a${name}`, '_blank');
    }
};
export const openAdvisoryLinkTelegram = (interestRate, advisoryLink, name) => {
    // only url encoding with telegram.me
    if (Platform.OS === 'web') {
        window.open(`https://telegram.me/share/url?url=Greetings%20🙏%0a%0aHelp%20your%20clients%20meet%20short%20term%20cash%20needs%20without%20redeeming%20mutual%20funds%2e%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20empanel%20now%2e%0a${advisoryLink}%0a%0aRegards%2c%0a${name}`);
    }
};
export const openAdvisorLinkWhatsAppOnPhone = (interestRate, advisoryLink, name) => {
    if (Platform.OS === 'web' && isFromAndroidWebview()) {
        window.open(`https://api.whatsapp.com//send?text=Greetings%20🙏%0a%0aHelp%20your%20clients%20meet%20short%20term%20cash%20needs%20without%20redeeming%20mutual%20funds%2e%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20empanel%20now%2e%0a${advisoryLink}%0a%0aRegards%2c%0a${name}`, '_blank');
    }
    else if (Platform.OS === 'web') {
        window.open(`whatsapp://send?text=Greetings%20🙏%0a%0aHelp%20your%20clients%20meet%20short%20term%20cash%20needs%20without%20redeeming%20mutual%20funds%2e%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20empanel%20now%2e%0a${advisoryLink}%0a%0aRegards%2c%0a${name}`, '_parent');
    }
};
export const isFromiOSBrowser = () => {
    if (Platform.OS === "web") {
        const userAgent = window.navigator.userAgent;
        return userAgent.includes('iPhone');
    }
};
export const onShareAdvisory = async (interestRate, advisoryLink, name) => {
    if (isFromAndroidWebview()) {
        window.open(`${advisoryLink}advisoryLink`);
    }
    else {
        try {
            const result = await Share.share({
                message: `Greetings 🙏\n\nHelp your clients meet short term cash needs without redeeming mutual funds.\n\nUse Volt to open a credit line(OD) against mutual funds in 5 minutes with trusted lenders such as Bajaj Finance.\n\nInterest rates starting at ${interestRate}. Use this link to empanel now.\n${advisoryLink}\n\nRegards,\n${name}`,
            });
            if (result.action === Share.sharedAction) {
                if (result.activityType) {
                    // shared with activity type of result.activityType
                }
                else {
                    // shared
                }
            }
            else if (result.action === Share.dismissedAction) {
                // dismissed
            }
        }
        catch (e) {
            console.log(e);
        }
    }
};
export const addDaysToEpochTime = (epochTime, days) => {
    const date = new Date(epochTime);
    const dateAfterAddingDays = date.setDate(date.getDate() + days);
    return dateAfterAddingDays.valueOf();
};
export var GoogleUtmParams;
(function (GoogleUtmParams) {
    GoogleUtmParams["UTM_CAMPAIGN"] = "utm_campaign";
    GoogleUtmParams["UTM_CONTENT"] = "utm_content";
    GoogleUtmParams["UTM_ID"] = "utm_id";
    GoogleUtmParams["UTM_MEDIUM"] = "utm_medium";
    GoogleUtmParams["UTM_SOURCE"] = "utm_source";
})(GoogleUtmParams || (GoogleUtmParams = {}));
export const isGoogleUTMParams = param => {
    if (param === GoogleUtmParams.UTM_SOURCE ||
        param === GoogleUtmParams.UTM_CONTENT ||
        param === GoogleUtmParams.UTM_ID ||
        param === GoogleUtmParams.UTM_CAMPAIGN ||
        param === GoogleUtmParams.UTM_MEDIUM) {
        return true;
    }
    return false;
};
export const getParamsLink = (url, append = false, includeAllParams = false) => {
    const params = Platform.OS === 'web' && url ? getParameters(url) : {};
    let resultString = '';
    let localStoredParams = {};
    // check if params exist in localstorage if not present in query string
    const utm_campaign = params?.utm_campaign;
    const utm_content = params?.utm_content;
    const utm_id = params?.utm_id;
    const utm_medium = params?.utm_medium;
    const utm_source = params?.utm_source;
    const cachedUtm = localStorage.getItem(StoreKey.UTM_PARAMS);
    if (utm_campaign || utm_content || utm_id || utm_medium || utm_source) {
        Object.keys(params).forEach(param => {
            //store google utm params in localStorage
            if (isGoogleUTMParams(param)) {
                localStoredParams = {
                    ...localStoredParams,
                    time: addDaysToEpochTime(Date.now().valueOf(), UTM_expiry_days),
                    [`${param}`]: params[param],
                };
            }
            if (param !== 'time') {
                console.log("param 123: ", param);
                resultString += `${param}=${params[`${param}`]}&`;
            }
        });
        localStorage.removeItem(StoreKey.UTM_PARAMS);
        localStoredParams &&
            localStorage.setItem(StoreKey.UTM_PARAMS, JSON.stringify(localStoredParams));
    }
    else {
        if (cachedUtm) {
            const cachedUtmJson = JSON.parse(cachedUtm);
            if (cachedUtmJson?.time && Date.now().valueOf() <= cachedUtmJson.time) {
                Object.keys(cachedUtmJson).forEach(param => {
                    //store google utm params in localStorage
                    if (param === 'time') {
                        //
                    }
                    else {
                        resultString += `${param}=${cachedUtmJson[`${param}`]}&`;
                    }
                });
            }
            else {
                //remove google utm params in localStorage when token expires
                localStorage.removeItem(StoreKey.UTM_PARAMS);
            }
        }
        else {
            Object.keys(params).forEach(param => {
                //store google utm params in localStorage
                resultString += `${param}=${params[`${param}`]}&`;
                console.log("resultString without utm and cache utm 123: ", resultString);
            });
        }
    }
    //add all params
    includeAllParams &&
        Object.keys(params).forEach(param => {
            if (!param.includes('utm')) {
                resultString += `${param}=${params[param]}&`;
            }
        });
    return append === true ? `${resultString}` : `?${resultString}`;
};
export const openInvestorLinkWhatsApp = (interestRate, investorLink, name) => {
    if (Platform.OS === 'web') {
        window.open(`https://api.whatsapp.com//send?text=Hi%2c%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20apply%20now%2e%0a${investorLink}%0a%0aRegards%2c%0a${name}`, '_blank');
    }
};
export const openInvestorLinkWhatsAppOnPhone = (interestRate, investorLink, name) => {
    if (Platform.OS === 'web') {
        window.open(`whatsapp://send?text=Hi%2c%0a%0aUse%20Volt%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%205%20minutes%20with%20trusted%20lenders%20such%20as%20Bajaj%20Finance%2e%0a%0aInterest%20rates%20starting%20at%20${interestRate}%2e%20Use%20this%20link%20to%20apply%20now%2e%0a${investorLink}%0a%0aRegards%2c%0a${name}`, '_parent');
    }
};
const Status = {
    DUE: 'Due',
    OVERDUE: 'Overdue',
    EXPIRED: 'Expired',
    SHORTFALL: 'Shortfall',
};
export const openUserLinkWhatsApp = (interestRate, investorLink, name, customer, currentActiveTabIndex) => {
    const customerName = customer?.fullName;
    const shortfall_amount = customer?.shortfallAmount;
    const shortfall_due_date = customer?.meetShortfallBy;
    const dueInterestMonth = customer?.dueInterestMonth;
    const interestDue = customer?.interestDue;
    const voltLink = 'https://voltm.app.link/get_volt_money';
    let message = '';
    if (currentActiveTabIndex === 1) {
        if (customer?.status === Status.DUE && customer?.mandateStatus === true) {
            message = `Dear ${customerName},\n\nTotal due amount for ${dueInterestMonth} is ₹${interestDue} for your Volt Money credit line account.Please ensure your bank account has enough funds for the automatic payment.\n\nFor more detail please visit Volt Money app:\n${voltLink}\n\nWarm regards,\n${name}`;
        }
        else if (customer?.status === Status.DUE) {
            message = `Dear ${customerName},\n\nTotal due amount for ${dueInterestMonth} is ₹${interestDue} for your Volt Money credit line account.Please pay due amount on the Volt Money App\n\nApp link: ${voltLink}\n\nWarm regards,\n${name}`;
        }
        else if (customer?.status === Status.OVERDUE) {
            message = `Dear ${customerName},\n\nPayment of ₹${interestDue} for your Volt Money credit line is overdue.\nTo avoid defaulting, pay now using the Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm regards,\n${name}`;
        }
    }
    else if (currentActiveTabIndex === 2) {
        if (customer?.status === Status.EXPIRED) {
            message = `Dear ${customerName},\n\nYour Volt Money credit line account has been expired.\n\nTo avoid penal charges and portfolio sell-off please settle your outstanding amount via Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm regards,\n${name}`;
        }
        else
            message = `Dear ${customerName},\n\nYour Volt Money credit line account is due for renewal.\n\nTo continue enjoying the benefits of credit line, Please renew your credit line account via Volt Money app.\n\nApp link: ${voltLink}\n\n Note:If you do not wish to continue your credit line account, please settle any outstanding amount before your account expires.\n\nIf you have already renewed, please ignore this message.\n\nWarm regards,\n${name}`;
    }
    else if (currentActiveTabIndex === 3) {
        message = `Dear ${customerName},\n\nYour Volt Money credit line account is currently in shortfall due to a decrease in the market value of your pledged portfolio.\n\nShortfall amount: ₹${shortfall_amount}\nDue date: ${shortfall_due_date}\n\nPlease make a payment to cover the shortfall amount or pledge additional portfolio via the Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm Regards,\n${name}`;
    }
    const encodedMessage = encodeURIComponent(message);
    if (Platform.OS === 'web') {
        window.open(`https://api.whatsapp.com//send?text=${encodedMessage}`, '_blank');
    }
};
export const openUserLinkWhatsAppOnPhone = (interestRate, investorLink, name, customer, currentActiveTabIndex) => {
    const customerName = customer?.fullName;
    const shortfall_amount = customer?.shortfallAmount;
    const shortfall_due_date = customer?.meetShortfallBy;
    const dueInterestMonth = customer?.dueInterestMonth;
    const interestDue = customer?.interestDue;
    const voltLink = 'https://voltm.app.link/get_volt_money';
    let message = '';
    if (currentActiveTabIndex === 1) {
        if (customer?.status === Status.DUE && customer?.mandateStatus === true) {
            message = `Dear ${customerName},\n\nTotal due amount for ${dueInterestMonth} is ₹${interestDue} for your Volt Money credit line account.Please ensure your bank account has enough funds for the automatic payment.\n\nFor more detail please visit Volt Money app:\n${voltLink}\n\nWarm regards,\n${name}`;
        }
        else if (customer?.status === Status.DUE) {
            message = `Dear ${customerName},\n\nTotal due amount for ${dueInterestMonth} is ₹${interestDue} for your Volt Money credit line account.Please pay due amount on the Volt Money App\n\nApp link: ${voltLink}\n\nWarm regards,\n${name}`;
        }
        else if (customer?.status === Status.OVERDUE) {
            message = `Dear ${customerName},\n\nPayment of ₹${interestDue} for your Volt Money credit line is overdue.\nTo avoid defaulting, pay now using the Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm regards,\n${name}`;
        }
    }
    else if (currentActiveTabIndex === 2) {
        if (customer?.status === Status.EXPIRED) {
            message = `Dear ${customerName},\n\nYour Volt Money credit line account has been expired.\n\nTo avoid penal charges and portfolio sell-off please settle your outstanding amount via Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm regards,\n${name}`;
        }
        else
            message = `Dear ${customerName},\n\nYour Volt Money credit line account is due for renewal.\n\nTo continue enjoying the benefits of credit line, Please renew your credit line account via Volt Money app.\n\nApp link: ${voltLink}\n\n Note:If you do not wish to continue your credit line account, please settle any outstanding amount before your account expires.\n\nIf you have already renewed, please ignore this message.\n\nWarm regards,\n${name}`;
    }
    else if (currentActiveTabIndex === 3) {
        message = `Dear ${customerName},\n\nYour Volt Money credit line account is currently in shortfall due to a decrease in the market value of your pledged portfolio.\n\nShortfall amount: ₹${shortfall_amount}\nDue date: ${shortfall_due_date}\n\nPlease make a payment to cover the shortfall amount or pledge additional portfolio via the Volt Money app.\n\nApp link: ${voltLink}\n\nIf you have already paid, please ignore this message.\n\nWarm Regards,\n${name}`;
    }
    const encodedMessage = encodeURIComponent(message);
    if (Platform.OS === 'web') {
        window.open(`whatsapp://send?text=${encodedMessage}`, '_parent');
    }
};
export const partnerNavigate = async (routeId) => {
    const routeName = routeId;
    const url = window.location.href;
    const queryParams = getParamsLink(url);
    const getActiveIndexTab = await AsyncStorage?.getItem("activeIndexTab");
    const routeConfig = routeName === ROUTE.PARTNER_SIGNUP
        ? ROUTE_PARTNER.SIGNUP
        : routeName === ROUTE.PARTNER_LEAD
            ? ROUTE_PARTNER.LEADS
            : routeName === ROUTE.PARTNER_ACTIVE_CUSTOMER
                ? ROUTE_PARTNER.ACTIVE_CUSTOMER
                : routeName === ROUTE.PARTNER_REFERRED_PARTNER
                    ? ROUTE_PARTNER.REFERRED_PARTNER
                    : routeName === ROUTE.COLLATERAL ? ROUTE_PARTNER.COLLATERAL
                        : routeName === ROUTE.PARTNER_CAPITAL_GAIN ? ROUTE_PARTNER.CAPITAL_GAIN
                            : ROUTE_PARTNER.DASHBOARD;
    if (Platform.OS === 'web') {
        if (getActiveIndexTab !== undefined && getActiveIndexTab !== null) {
            window.open(`/partner/${routeConfig}?activeIndexTab=${getActiveIndexTab}`, '_self');
        }
        else
            window.open(`/partner/${routeConfig}${queryParams && getParamsLink(url)}`, '_self');
    }
};
export const platformNavigate = async (routeId) => {
    const routeName = routeId;
    const routeConfig = routeName === ROUTE.PLATFORM_SIGN_UP
        ? ROUTE_PLATFORM.SIGNUP
        : routeName === ROUTE.PLATFORM_LEADS
            ? ROUTE_PLATFORM.LEADS
            : routeName === ROUTE.PLATFORM_ACTIVE_CUSTOMERS
                ? ROUTE_PLATFORM.ACTIVE_CUSTOMER
                : routeName === ROUTE.PLATFORM_LINKED_PARTNERS
                    ? ROUTE_PLATFORM.LINKED_PARTNER
                    : ROUTE_PLATFORM.DASHBOARD;
    if (Platform.OS === 'web') {
        window.open(`/platform/${routeConfig}`, '_self');
    }
};
export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};
export const sumObjectValues = (obj) => {
    return Object.entries(obj).reduce((sum, [_, value]) => sum + value, 0);
};
export const isPartnerAffiliated = (type) => {
    if (type) {
        return type === PartnerAccountType.AFFILIATE;
    }
    return false;
};
export const showInviteAndEarnTab = (partnerAccountType, user) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showMarketingPage == true && !isPartnerAffiliated(partnerAccountType)) {
        return true;
    }
    else if (partnerDashboardConfig?.showMarketingPage == false) {
        return false;
    }
    let _platformCode = '';
    let _partnerAccountType = '';
    if (user) {
        _platformCode = user?.linkedPlatformAccounts[0]?.platformCode;
        // return platformCode !== PLATFORM_CODE.SDK_INVESTWELL;
    }
    if (partnerAccountType) {
        _partnerAccountType = partnerAccountType;
        // return partnerAccountType !== PartnerAccountType.AFFILIATE
    }
    return _platformCode !== PLATFORM_CODE.SDK_INVESTWELL &&
        _partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const showCollateralTab = (partnerAccountType, user) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showCollaterals == true && !isPartnerAffiliated(partnerAccountType)) {
        return true;
    }
    else if (partnerDashboardConfig?.showCollaterals == false) {
        return false;
    }
    let _platformCode = '';
    let _partnerAccountType = '';
    if (user) {
        _platformCode = user?.linkedPlatformAccounts[0]?.platformCode;
    }
    if (partnerAccountType) {
        _partnerAccountType = partnerAccountType;
    }
    return _platformCode !== PLATFORM_CODE.SDK_INVESTWELL &&
        _partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const showMFDLedJourney = (partnerAccountType) => {
    return partnerAccountType === PartnerAccountType.INDIVIDUAL;
};
export const showPhoneNumber = (partnerAccountType) => {
    return partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const showTableActions = (partnerAccountType) => {
    return partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const showViewDetails = (partnerAccountType) => {
    return partnerAccountType === PartnerAccountType.INDIVIDUAL;
};
export const showEarning = (partnerAccountType, _user) => {
    const partnerDashboardConfig = _user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showEarnings == true && !isPartnerAffiliated(partnerAccountType)) {
        return true;
    }
    else if (partnerDashboardConfig?.showEarnings == false) {
        return false;
    }
    let showEarning = true;
    switch (partnerAccountType) {
        case PartnerAccountType.AFFILIATE:
            showEarning = true;
            break;
        case PartnerAccountType.INDIVIDUAL:
            showEarning = true;
            break;
        default:
            showEarning = false;
            break;
    }
    if (_user) {
        const platformCode = _user?.linkedPlatformAccounts[0]?.platformCode;
        if (platformCode === 'SDK_INVESTWELL') {
            showEarning = false;
        }
    }
    return showEarning;
};
export const showViewCustomerPortfolio = (partnerAccountType, _user) => {
    const partnerDashboardConfig = _user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showCustomerPortfolio == true && !isPartnerAffiliated(partnerAccountType)) {
        return true;
    }
    else if (partnerDashboardConfig?.showCustomerPortfolio == false) {
        return false;
    }
    let show = true;
    switch (partnerAccountType) {
        case PartnerAccountType.AFFILIATE:
            show = false;
            break;
        case PartnerAccountType.INDIVIDUAL:
            show = true;
            break;
        default:
            show = false;
            break;
    }
    if (_user) {
        const platformCode = _user?.linkedPlatformAccounts[0]?.platformCode;
        if (platformCode === 'SDK_INVESTWELL') {
            show = false;
        }
    }
    return show;
};
export const showPartnerEarning = (showEarning) => {
    return (getBuildType() === BUILD_TYPE.PARTNER_STAGING || getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION) && showEarning;
};
export const showMarketing = (partnerAccountType) => {
    if (partnerAccountType === PartnerAccountType.AFFILIATE) {
        return false;
    }
    return true;
};
export const showPromoCard = (partnerAccountType) => {
    return partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const showMFC = (partnerAccountType, user) => {
    const partnerDashboardConfig = user?.linkedPlatformAccounts[0]?.platformPartnerDashboardConfig;
    if (partnerDashboardConfig?.showCheckEligibility == true) {
        return true;
    }
    else if (partnerDashboardConfig?.showCheckEligibility == false) {
        return false;
    }
    let _partnerAccountType = '';
    if (partnerAccountType) {
        _partnerAccountType = partnerAccountType;
        return _partnerAccountType !== PartnerAccountType.AFFILIATE;
    }
    return true;
};
export const showARNNumber = (partnerAccountType) => {
    return partnerAccountType !== PartnerAccountType.AFFILIATE;
};
export const isAccessTokenStale = async ({ asyncStorage, network }) => {
    const access_Token = JSON.parse(JSON.stringify(AsyncStorage.getItem(StoreKey.accessToken)));
    if (access_Token) {
        const header = await getAppHeader();
        header['X-AppPlatform'] = 'VOLT_WEB_APP';
        const response = await network.post(partnerApi.userContext, {}, { headers: header }, async () => {
            return;
        }, {
            isPartnerPlatform: true,
        });
        if (response["status"] === 200) {
            const _user = response?.data;
            await asyncStorage.set(StoreKey.userContext, JSON.stringify(_user));
            return false;
        }
        else {
            return true;
        }
    }
    return true;
};
export const partnerRouteConfig = (routeName) => {
    let routeConfig = '';
    switch (routeName) {
        case ROUTE.PARTNER_SIGNUP:
            routeConfig = ROUTE_PARTNER.SIGNUP;
            break;
        case ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO:
            routeConfig = ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO;
            break;
        default:
            routeConfig = routeName === ROUTE.EARNING ?
                ROUTE_PARTNER.EARNING :
                routeName === ROUTE.PARTNER_CHECK_LIMIT ?
                    ROUTE_PARTNER.CHECK_LIMIT :
                    routeName === ROUTE.COLLATERAL ?
                        ROUTE_PARTNER.COLLATERAL :
                        routeName === ROUTE.MY_ACCOUNT ?
                            ROUTE_PARTNER.MY_ACCOUNT :
                            routeName === ROUTE.DEMO_VIDEOS ?
                                ROUTE_PARTNER.DEMO_VIDEOS :
                                routeName === ROUTE.PARTNER_LEAD
                                    ? ROUTE_PARTNER.LEADS
                                    : routeName === ROUTE.PARTNER_ACTIVE_CUSTOMER
                                        ? ROUTE_PARTNER.ACTIVE_CUSTOMER
                                        : routeName === ROUTE.PARTNER_REFERRED_PARTNER
                                            ? ROUTE_PARTNER.REFERRED_PARTNER
                                            : routeName === ROUTE.PARTNER_CAPITAL_GAIN
                                                ? ROUTE_PARTNER.CAPITAL_GAIN
                                                : ROUTE_PARTNER.DASHBOARD;
    }
    return routeConfig;
};
export const getLenderInfo = async (network) => {
    const user = await sharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const lenderInfoResponse = await network.get(`${api.getLenderInfo}${applicationId}`, {
        headers: await getAppHeader()
    });
    if (lenderInfoResponse.status === 200) {
        return lenderInfoResponse.data;
    }
    return {
        lenderAccountId: "Mirae",
        lenderName: "Mirae Assets Financial Service",
        lenderLogoUrl: "https://localhost:8080"
    };
};
export const isFromJupiter = async () => {
    return await SharedPropsService.getAppPlatform() === "JUPITER";
};
export const appendURlWithParam = (paramName) => {
    const url = window.location.href;
    const urlParts = url.split('/');
    urlParts[urlParts.length - 1] = paramName;
    const newUrl = urlParts.join('/');
    console.log(newUrl);
    window.history.pushState('', '', newUrl);
};
export const getAutoDebitDate = async (network, lenderDetailsFromApi) => {
    const lenderInfo = lenderDetailsFromApi ? lenderDetailsFromApi : await getLenderInfo(network);
    const date = lenderInfo?.lenderBusinessDetails?.autopayDate;
    let resultDate = '';
    switch (Number.parseInt(date)) {
        case 1:
            resultDate = `${date}st of every month`;
            break;
        case 2:
            resultDate = `${date}nd of every month`;
            break;
        case 3:
            resultDate = `${date}rd of every month`;
            break;
        default:
            resultDate = `${date}th of every month`;
            break;
    }
    return resultDate;
};
export const getLenderImageDimension = (lenderId) => {
    let height = 0;
    let width = 0;
    switch (lenderId.toLowerCase()) {
        case LENDER_ID.MIRAE:
            height = 22;
            width = 96;
            break;
        case LENDER_ID.TATA:
            height = 18;
            width = 98;
            break;
        case LENDER_ID.BAJAJ:
            height = 18;
            width = 68;
            break;
    }
    return { height, width };
};
export const isASESAllowedForLender = (lenderId) => {
    switch (lenderId.toLowerCase()) {
        case LENDER_ID.MIRAE:
            return false;
            break;
        case LENDER_ID.TATA:
            return false;
            break;
        case LENDER_ID.BAJAJ:
            return true;
            break;
        case LENDER_ID.NUVAMA:
            return false;
            break;
        case LENDER_ID.DSP:
            return false;
            break;
        default:
            return false;
            break;
    }
    return true;
};
export const getLenderIcon = (lenderId) => {
    switch (lenderId.toLowerCase()) {
        case LENDER_ID.MIRAE:
            return IconTokens.LENDER_MIRAE;
            break;
        case LENDER_ID.TATA:
            return IconTokens.LENDER_TATA;
            break;
        case LENDER_ID.BAJAJ:
            return IconTokens.BAJAJ_FULL_LOGO_NEW;
            break;
        case LENDER_ID.NUVAMA:
            return IconTokens.LENDER_NUVAMA;
            break;
        case LENDER_ID.DSP:
            return IconTokens.DSP_LOGO;
            break;
        default:
            return IconTokens.BAJAJ_FULL_LOGO_NEW;
            break;
    }
    return true;
};
export const getKFSData = async (network) => {
    const _user = await sharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = _user?.linkedApplications[0]?.applicationId;
    }
    const kfs_data_reponse = await network.get(`${api.getKfsData}${applicationId}`, {
        headers: await getAppHeader()
    });
    if (kfs_data_reponse?.status === 200) {
        return kfs_data_reponse?.data?.lenderKFSDetails;
    }
    return null;
};
export const getKFSDataBajaj = async (network) => {
    const _user = await sharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : _user?.linkedApplications[0]?.applicationId;
    const kfs_data_reponse = await network.get(`${api.getBajajKfs}${applicationId}`, {
        headers: await getAppHeader()
    });
    if (kfs_data_reponse?.status === 200) {
        return kfs_data_reponse?.data?.stepResponseObject;
    }
    return null;
};
export const getTermsLinks = () => {
    return `${VoltWebSiteBaseLink}terms?showHeader=false`;
};
export const getPrivacyLinks = () => {
    return `${VoltWebSiteBaseLink}privacy?showHeader=false`;
};
export const getTclLink = () => {
    return `https://www.tatacapital.com/`;
};
export const showFaq = (user) => {
    const platform = user?.linkedPlatformAccounts[0]?.platformCode;
    return platform !== 'REDVISION';
};
export const getMinAllowedAmountBasedOnLender = (lenderId) => {
    switch (lenderId.toLowerCase()) {
        case LENDER_ID.MIRAE.toLowerCase():
            return 10000;
            break;
        case LENDER_ID.TATA.toLowerCase():
            return 25000;
            break;
        case LENDER_ID.BAJAJ.toLowerCase():
            return 25000;
            break;
        case LENDER_ID.NUVAMA.toLowerCase():
            return 10000;
            break;
        default:
            return 25000;
            break;
    }
};
export const getDigioConfigPlatformSpecific = (sdkConfigObj) => {
    if (sdkConfigObj) {
        return {
            primaryColor: `#${sdkConfigObj?.primaryColor}`,
            secondaryColor: `#${sdkConfigObj?.primaryColor}`,
            companyUrl: sdkConfigObj?.customLogoUrl
        };
    }
    return {
        primaryColor: '#234FDA',
        secondaryColor: '#234FDA',
        companyUrl: 'https://volt-images.s3.ap-south-1.amazonaws.com/volt-website-header.svg'
    };
};
export const addSuffix = (day) => {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    switch (day % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
export const getDateMonthYearFromEpoch = (epochNumber) => {
    if (!epochNumber)
        return ""; // Handle undefined case
    const newDateToPick = new Date(epochNumber); // JavaScript automatically adjusts to local timezone
    const displayDate = newDateToPick.getDate().toString().padStart(2, '0');
    const dateName = `${displayDate}${addSuffix(Number(displayDate))}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = newDateToPick.getMonth();
    const currentYear = newDateToPick.getFullYear();
    return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;
};
export const getDateMonthYearFromEpochFromMicroseconds = (epochNumber) => {
    if (!epochNumber)
        return ""; // Handle undefined case
    const newDateToPick = new Date(epochNumber * 1000); // JavaScript automatically adjusts to local timezone
    const displayDate = newDateToPick.getDate().toString().padStart(2, '0');
    const dateName = `${displayDate}${addSuffix(Number(displayDate))}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = newDateToPick.getMonth();
    const currentYear = newDateToPick.getFullYear();
    return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;
};
export const getDateMonthYearFormat = (epoch) => {
    const date = new Date(epoch);
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    return `${day}${addSuffix(day)} ${month}, ${year}`;
};
export const getDateMonthYearFromEpochIst = (epochNumber) => {
    const newDateToPick = new Date(epochNumber);
    // const IST_OFFSET = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(newDateToPick.getTime());
    const displayDate = istDate.getDate();
    const dateName = `${displayDate}${addSuffix(displayDate)}`;
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    const getMonthName = istDate.getMonth();
    const currentYear = istDate.getFullYear();
    return `${dateName} ${monthNames[getMonthName]}, ${currentYear}`;
};
export const getDateMonthYearFromEpochInIST = (epochNumber) => {
    if (!epochNumber)
        return null;
    const options = {
        timeZone: 'Asia/Kolkata',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };
    //@ts-ignore
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const formattedDateParts = formatter.formatToParts(new Date(epochNumber));
    const day = formattedDateParts.find(part => part.type === 'day').value;
    const month = formattedDateParts.find(part => part.type === 'month').value;
    const year = formattedDateParts.find(part => part.type === 'year').value;
    return `${day}${addSuffix(day)} ${month}, ${year}`;
};
export const getDateMonthYearFromEpochV2 = (epochNumber) => {
    if (!epochNumber)
        return null;
    const dateObject = new Date(epochNumber);
    if (isNaN(dateObject.getTime())) {
        console.error("Invalid date detected:", epochNumber);
        return null; // Prevent further errors
    }
    console.log(Intl.DateTimeFormat().resolvedOptions().timeZone, "skm1233");
    const formatter = new Intl.DateTimeFormat('en-US');
    const formattedDateParts = formatter?.formatToParts(dateObject);
    const day = formattedDateParts.find(part => part.type === 'day')?.value;
    const month = formattedDateParts.find(part => part.type === 'month')?.value;
    const year = formattedDateParts.find(part => part.type === 'year')?.value;
    const result = `${day}${addSuffix(day)} ${month}, ${year}`;
    return result;
};
export const setAppHeader = async (platformCode, addUseProperty) => {
    await initializeFirebase();
    if (Platform.OS === 'web') {
        const params = getParametersFromURL();
        const isFromPartnerApp = params[QUERY_PARAMS.IS_FROM_PARTNER_APP];
        const platformCode = params?.[QUERY_PARAMS.PLATFORM];
        if (platformCode) {
            await sharedPropsService.setAppPlatform(platformCode);
            addUseProperty && addUseProperty('x-appPlatform', platformCode);
        }
        else if (isFromPartnerApp) {
            await SharedPropsService.setAppPlatform(PLATFORM_CODE.VOLT_PARTNER_ANDROID_APP);
            addUseProperty && addUseProperty('x-appPlatform', PLATFORM_CODE.VOLT_PARTNER_ANDROID_APP);
        }
        else {
            await sharedPropsService.setAppPlatform(PLATFORM_CODE.VOLT_WEB_APP);
            addUseProperty && addUseProperty('x-appPlatform', PLATFORM_CODE.VOLT_WEB_APP);
        }
    }
};
export const suffixDateChar = (date) => {
    let suffixDateChar = "th";
    if (Number(date) >= 11 && Number(date) <= 13) {
        suffixDateChar = 'th';
    }
    switch (Number(date) % 10) {
        case 1:
            suffixDateChar = 'st';
            break;
        case 2:
            suffixDateChar = 'nd';
            break;
        case 3:
            suffixDateChar = 'rd';
            break;
        default:
            suffixDateChar = 'th';
    }
    return suffixDateChar;
};
export const getDaysDelta = async (epochTime) => {
    const config = await SharedPropsService.getFirebaseConfig();
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const loan_renewal_test_flag = config?.loan_renewal_test_flag;
    const loan_renewal_test_current_date = config?.loan_renewal_test_current_date;
    const endMomentDate = moment(epochTime);
    // const currentDate = moment().startOf('day');
    // const currentDate = (loan_renewal_test_flag === true || loan_renewal_test_flag==='true') ? await mockCurrentDate(true) : moment();
    let currentDate;
    if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') {
        currentDate = moment(`${loan_renewal_test_current_date}T00:00:00`);
    }
    else {
        currentDate = moment();
    }
    if (currentDate.isSame(endMomentDate, 'day') && lenderId?.toLowerCase() !== LENDER_ID.TATA) {
        console.log("Same day;");
        return -1;
    }
    const endDate = endMomentDate; // Current date/time
    const daysDifference = endDate.diff(currentDate, 'day');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    if (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') {
        if (daysDifference > 0) {
            return daysDifference;
        }
        return (Math.abs(daysDifference) + 2);
    }
    if (lenderId?.toLowerCase() === LENDER_ID.TATA) {
        const currentTime = moment().startOf('day');
        const endMomentTime = moment(epochTime).startOf('day');
        if (currentTime?.isSame(endMomentTime, 'day')) {
            return 1;
        }
        let daysDifference = endMomentTime?.diff(currentTime, 'days');
        return Math.abs(daysDifference) + 1;
    }
    console.log("daysDifference: FF", Math.abs(daysDifference));
    return Math.abs(daysDifference);
};
export const getEpochTimeInMillisecondsFromDaysFromNow = (daysFromNow) => {
    // Get the current moment
    const currentMoment = moment();
    // Add the specified number of days
    const futureMoment = currentMoment.add(daysFromNow, 'days');
    // Get the epoch time in milliseconds
    const epochTimeInMilliseconds = futureMoment.unix() * 1000;
    return epochTimeInMilliseconds;
};
export const getEpochTimeInMillisecondsFromDaysAgo = (daysFromNow) => {
    // Get the current moment
    const currentMoment = moment();
    // Add the specified number of days
    const pastMoments = currentMoment.subtract(daysFromNow, 'days');
    // Get the epoch time in milliseconds
    const epochTimeInMilliseconds = pastMoments.unix() * 1000;
    return epochTimeInMilliseconds;
};
export const getApplicationId = async () => {
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    return applicationId;
};
export const daysToMonths = (days) => {
    const duration = moment.duration(days, 'days');
    const months = duration.asMonths();
    return Math.ceil(months);
};
export const SHOW_NEW_WITHDRAW_FLOW = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_withdrawl = await sharedPropsService.getFirebaseConfig()?.show_new_withdraw_flow_test_numbers;
    if (!test_numbers_withdrawl) {
        return false;
    }
    const test_numbers_withdrawl_object = JSON.parse(test_numbers_withdrawl);
    const show_withdrawl_test_phoneNumbers = test_numbers_withdrawl_object?.numbers
        ? test_numbers_withdrawl_object?.numbers
        : [];
    const config = await sharedPropsService?.getFirebaseConfig();
    const showNewWithdrawFlow = config?.show_new_withdraw_flow;
    if (showNewWithdrawFlow &&
        (showNewWithdrawFlow === true ||
            showNewWithdrawFlow === "true")) {
        return true;
    }
    else {
        return show_withdrawl_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const foreclosureCheck = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_foreclosure_check = await sharedPropsService.getFirebaseConfig()?.foreclosure_check_test_numbers;
    if (!test_numbers_foreclosure_check) {
        return false;
    }
    const test_numbers_foreclosure_check_object = JSON.parse(test_numbers_foreclosure_check);
    const show_foreclosure_check_test_phoneNumbers = test_numbers_foreclosure_check_object?.numbers
        ? test_numbers_foreclosure_check_object?.numbers
        : [];
    const config = await sharedPropsService?.getFirebaseConfig();
    const showForeclosureCheck = config?.foreclosure_check;
    if (showForeclosureCheck &&
        (showForeclosureCheck === true ||
            showForeclosureCheck === "true")) {
        return true;
    }
    else {
        return show_foreclosure_check_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const showLeinRemovalTrackingFlow = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const leinRemovalFirebaseConfig = await sharedPropsService.getFirebaseConfig()?.lein_removal_tracking;
    if (!leinRemovalFirebaseConfig) {
        return false;
    }
    const leinRemovalFirebaseObject = JSON.parse(leinRemovalFirebaseConfig);
    const leinRemovalTestNumbers = leinRemovalFirebaseObject?.numbers
        ? leinRemovalFirebaseObject?.numbers
        : [];
    const config = await sharedPropsService?.getFirebaseConfig();
    const showLeinRemovalTrackingFlow = config?.lein_removal_master_config;
    if (showLeinRemovalTrackingFlow &&
        (showLeinRemovalTrackingFlow === true ||
            showLeinRemovalTrackingFlow === "true")) {
        return true;
    }
    else {
        return leinRemovalTestNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const isTestStagingEnvironment = () => {
    return getBuildType() === BUILD_TYPE.BORROWER_TEST_STAGING;
};
export const allowSessionCache = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const session_cache_flag = await sharedPropsService.getFirebaseConfig()?.session_cache_flag;
    const session_cache_test_numbers = await sharedPropsService.getFirebaseConfig()?.session_cache_test_numbers;
    if (!session_cache_flag) {
        return false;
    }
    //@ts-ignore
    if (session_cache_flag && session_cache_flag === 'true') {
        return true;
    }
    if (session_cache_test_numbers &&
        session_cache_test_numbers !== '') {
        let session_cache_test_numbers_json = JSON.parse(session_cache_test_numbers);
        session_cache_test_numbers_json = session_cache_test_numbers_json?.numbers
            ? session_cache_test_numbers_json?.numbers
            : [];
        return session_cache_test_numbers_json.includes(userPhoneNumber?.slice(3));
    }
    return false;
};
export const getForeClosureDetails = async (network, { creditId = undefined, overrideCache = false } = {}) => {
    const _user = await sharedPropsService.getUser();
    const _creditId = _user?.linkedCredits[0]?.creditId;
    const foreClosureDetailsFromCache = await sharedPropsService.getForeClosureDetails();
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const getForeClosureResponse = await network.get(`${api.getForeclosureDetails}${creditId ? creditId : _creditId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        });
        if (getForeClosureResponse?.status === 200) {
            await sharedPropsService.setForeClosureDetails(getForeClosureResponse?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.getForeclosureDetails}${creditId ? creditId : _creditId}`);
                console.log('API DATA: ', getForeClosureResponse?.data);
                console.log('----------------------');
            }
            return getForeClosureResponse?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if ((overrideCache === true ||
        foreClosureDetailsFromCache === undefined)) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getForeClosureDetails();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.getForeclosureDetails}${creditId ? creditId : _creditId}`);
            console.log('API DATA: ', data);
            console.log('-------------------------------');
        }
        return await sharedPropsService.getForeClosureDetails();
    }
};
export const getCreditData = async (network, { creditId = undefined, overrideCache = false } = {}) => {
    const creditDataFromCache = await sharedPropsService.getCreditData();
    const _user = await sharedPropsService.getUser();
    const _creditId = _user?.linkedCredits[0]?.creditId;
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const creditResponse = await network.get(`${api.getCredit}/${_creditId}`, {
            headers: await getAppHeader(),
        });
        if (creditResponse?.status === 200) {
            await sharedPropsService.setCreditData(creditResponse?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.getCredit}/${_creditId}`);
                console.log('API DATA: ', creditResponse?.data);
                console.log('----------------------');
            }
            return creditResponse?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if (overrideCache === true ||
        creditDataFromCache === undefined) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getCreditData();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.getCredit}/${_creditId}`);
            console.log('API DATA: ', data);
            console.log('----------------------');
        }
        return data;
    }
};
export const getUserContext = async (network, { overrideCache = false } = {}) => {
    const userDataFromCache = await sharedPropsService.getUser();
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const body = {};
        const userContextResponse = await network.post(api.userContext, body, {
            headers: await getAppHeader()
        });
        if (userContextResponse?.status === 200) {
            await sharedPropsService.setUser(userContextResponse?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.userContext}`);
                console.log('API DATA: ', userContextResponse?.data);
                console.log('----------------------');
            }
            return userContextResponse?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if (overrideCache === true ||
        userDataFromCache === undefined ||
        userDataFromCache === null) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getUser();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.userContext}`);
            console.log('API DATA: ', data);
            console.log('----------------------');
        }
        return data;
    }
};
export const getBorrowerProfile = async (network, { overrideCache = false } = {}) => {
    const BorrowerProfileDataFromCache = await sharedPropsService.getBorrowerUserProfile();
    const _user = await sharedPropsService.getUser();
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const body = {};
        const response = await network.get(`${api.userProfile}${_user?.linkedBorrowerAccounts[0]?.accountId}`, {
            headers: await getAppHeader(),
        });
        if (response?.status === 200) {
            await sharedPropsService.setBorrowerUserProfile(response?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.userProfile}${_user?.linkedBorrowerAccounts[0]?.accountId}`);
                console.log('API DATA: ', response?.data);
                console.log('----------------------');
            }
            return response?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if (overrideCache === true ||
        BorrowerProfileDataFromCache === undefined ||
        BorrowerProfileDataFromCache === null) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getBorrowerUserProfile();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.userProfile}${_user?.linkedBorrowerAccounts[0]?.accountId}`);
            console.log('API DATA: ', data);
            console.log('----------------------');
        }
        return data;
    }
};
export const getManageLimitConfig = async (network, { overrideCache = false } = {}) => {
    const manageLimitConfigDataFromCache = await sharedPropsService.getManageLimitConfigData();
    const _user = await sharedPropsService.getUser();
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const response = await network.get(`${api.manageLimitConfig}${_user.linkedCredits[0].creditId}`, {
            headers: await getAppHeader(),
        });
        if (response?.status === 200) {
            await sharedPropsService.setManageLimitConfigData(response?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.manageLimitConfig}${_user.linkedCredits[0].creditId}`);
                console.log('API DATA: ', response?.data);
                console.log('----------------------');
            }
            return response?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if (overrideCache === true ||
        manageLimitConfigDataFromCache === undefined ||
        manageLimitConfigDataFromCache === null) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getManageLimitConfigData();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.manageLimitConfig}${_user.linkedCredits[0].creditId}`);
            console.log('API DATA: ', data);
            console.log('----------------------');
        }
        return data;
    }
};
export const getPendingCreditRequestByCreditId = async (network, { overrideCache = false } = {}) => {
    const pendingCreditRequestsByCreditIdData = await sharedPropsService.getPendingCreditRequestsByCreditIdData();
    const _user = await sharedPropsService.getUser();
    const allowCache = await allowSessionCache();
    const networkCall = async () => {
        const response = await network.get(
        // `${api.getPendingStatus}${userContextResponse?.data?.linkedCredits[0]?.creditId}`,
        `${api.getPendingStatus}${_user?.linkedCredits[0]?.creditId}`, {
            headers: await getAppHeader(),
        });
        if (response?.status === 200) {
            await sharedPropsService.setPendingCreditRequestsByCreditIdData(response?.data);
            if (isTestStagingEnvironment()) {
                console.log('------ API DATA ------');
                console.log('API NAME: ', `${api.getPendingStatus}${_user?.linkedCredits[0]?.creditId}`);
                console.log('API DATA: ', response?.data);
                console.log('----------------------');
            }
            return response?.data;
        }
        else {
            return undefined;
        }
    };
    if (!allowCache) {
        return await networkCall();
    }
    if (overrideCache === true ||
        pendingCreditRequestsByCreditIdData === undefined ||
        pendingCreditRequestsByCreditIdData === null) {
        return await networkCall();
    }
    else {
        const data = await sharedPropsService.getPendingCreditRequestsByCreditIdData();
        if (isTestStagingEnvironment()) {
            console.log('------ API DATA (CACHED) ------');
            console.log('API NAME: ', `${api.getPendingStatus}${_user?.linkedCredits[0]?.creditId}`);
            console.log('API DATA: ', data);
            console.log('----------------------');
        }
        return data;
    }
};
export const mockCurrentDate = async (inTimeStamp) => {
    const config = await SharedPropsService.getFirebaseConfig();
    const loan_renewal_test_current_date = config?.loan_renewal_test_current_date;
    const feb1stIST = moment(`${loan_renewal_test_current_date}T00:00:00`);
    if (inTimeStamp) {
        return feb1stIST;
    }
    return moment(`${loan_renewal_test_current_date}T00:00:00`).unix() * 1000;
};
export const getDaysInMonth = () => {
    const currentMonth = moment().month();
    const daysInMonth = moment().month(currentMonth).daysInMonth();
    console.log("daysInMonth: ", daysInMonth);
    return daysInMonth;
};
export const addMonthsToEpochTimetamp = (epoch, noOfMonths) => {
    const momentDate = moment(epoch).startOf('day');
    const newMomentDate = momentDate.add(noOfMonths, 'months');
    const updatedEpochDate = newMomentDate.unix() * 1000;
    return updatedEpochDate;
};
export const showNewDashboardWithdrawCard = async () => {
    const config = await sharedPropsService?.getFirebaseConfig();
    const showNewDashboardCard = config?.SHOW_NEW_DASHBOARD_WITHDRAW_CARD;
    if (showNewDashboardCard &&
        (showNewDashboardCard === true ||
            showNewDashboardCard === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const addSupportAmplitudeEvent = async (instrumentTrack, eventName) => {
    const routeId = await AsyncStorage.getItem(StoreKey.ROUTE_ID);
    if (routeId) {
        await instrumentTrack(eventName, {
            [AMPLITUDE_EVENT_PROPERTY.CURRENT_SCREEN]: routeId
        });
    }
};
export const convertTimeStampToFormattedTime = (timestamp) => {
    if (timestamp === null || timestamp === undefined)
        return "";
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedDate = `${formattedHours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}, ${date.getDate()}-${date.toLocaleString('default', { month: 'short' })}`;
    return formattedDate;
};
export const getWithdrawTempDate = async () => {
    const config = await sharedPropsService?.getFirebaseConfig();
    return config?.show_new_withdraw_temp_date;
};
export const getISTTime = (epoch) => {
    const newDate = new Date(epoch);
    const options = {
        timeZone: 'Asia/Calcutta',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
    };
    //@ts-ignore
    return newDate.toLocaleString('en-US', options);
};
export const getISTTimeV2 = (epoch) => {
    const newDate = new Date(epoch);
    return newDate.toLocaleString('en-US');
};
export const ShowNewRTAFetchError = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers = await sharedPropsService.getFirebaseConfig()?.RTA_fetch_error_handle_numbers;
    if (!test_numbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(test_numbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const RTA_fetch_error_handle_flag = await SharedPropsService.getFirebaseConfig()?.RTA_fetch_error_handle_flag;
    if (RTA_fetch_error_handle_flag &&
        (RTA_fetch_error_handle_flag === true ||
            RTA_fetch_error_handle_flag === 'true')) {
        return true;
    }
    else {
        return show_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const ShowNewMandateError = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers = await sharedPropsService.getFirebaseConfig()?.show_new_mandate_error_flow_test_numbers;
    if (!test_numbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(test_numbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const show_new_mandate_error_flow = await SharedPropsService.getFirebaseConfig()?.show_new_mandate_error_flow;
    if (show_new_mandate_error_flow &&
        (show_new_mandate_error_flow === true ||
            show_new_mandate_error_flow === 'true')) {
        return true;
    }
    else {
        return show_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export const showShortFallCard = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_shortFall = await sharedPropsService.getFirebaseConfig()?.shortfall_card_test_number;
    const showShortFallDetails = await sharedPropsService?.getFirebaseConfig()?.shortfall_card;
    if (showShortFallDetails && (showShortFallDetails === true || showShortFallDetails === "true"))
        return true;
    if (!test_numbers_shortFall) {
        return false;
    }
    const test_numbers_shortFall_object = JSON.parse(test_numbers_shortFall);
    const show_shortFall_test_phoneNumbers = test_numbers_shortFall_object?.numbers
        ? test_numbers_shortFall_object?.numbers
        : [];
    return show_shortFall_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
};
export const getShortfallFaqDetails = async () => {
    const remoteConfig = await sharedPropsService.getFirebaseConfig();
    const shortfallFaqDetails = remoteConfig?.shortfall_card_faq;
    const details = JSON.parse(shortfallFaqDetails);
    return details;
};
export const adjustOpacity = (color, opacity) => {
    const hexWithoutAlpha = color.slice(0, 7); // Remove alpha channel
    const alphaDecimal = Math.round(opacity * 255);
    const alphaHex = alphaDecimal.toString(16).padStart(2, '0'); // Pad with zeros if needed
    const colorWithAdjustedOpacity = `${hexWithoutAlpha}${alphaHex}`;
    return colorWithAdjustedOpacity.toUpperCase();
};
export const getBackgroundColor = () => {
    if (Platform.OS === 'web') {
        const params = getParametersFromURL();
        console.log('getBackgroundColor params: ', params);
        if (params?.platform === "TATADIGITAL" /* AppPlatform.TDL */)
            return 'EBF0FF';
        if (params?.primaryColor) {
            return `${adjustOpacity(params?.primaryColor, 0.05)}`;
        }
    }
    return `F3F5FC`;
};
export const getBackgroundColorDashboard = () => {
    if (Platform.OS === 'web') {
        const params = getParametersFromURL();
        console.log('getBackgroundColor params: ', params);
        if (params?.platform === "TATADIGITAL" /* AppPlatform.TDL */)
            return 'EBF0FF';
        if (params?.primaryColor) {
            return `${adjustOpacity(params?.primaryColor, 0.05)}`;
        }
    }
    return `F3F5FC`;
};
export const isFromJsSDK = () => {
    if (Platform.OS === 'web') {
        const url = window.location.href;
        const params = getParameters(url);
        if (params?.isFromJsSDK) {
            return true;
        }
    }
    return false;
};
export const showSupportNUmberForPartner = async () => {
    const isFromTataDigital = await SharedPropsService.getAppPlatform() === "TATADIGITAL" /* AppPlatform.TDL */;
    const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
    const isFromPrudent = await SharedPropsService.getAppPlatform() === "PRUDENT" /* AppPlatform.PRUDENT */;
    const isFromZype = await SharedPropsService.getAppPlatform() === "ZYPE" /* AppPlatform.ZYPE */;
    if (isFromTataDigital || isFromJupiter || isFromPrudent || isFromZype) {
        return true;
    }
    else
        return false;
};
export const getContactUsDetails = async () => {
    const res = {
        whatsappNumber: '',
        callNumber: '',
        email: '',
        isFromPhonePe: false,
        showSupportPhoneNumber: false,
        showEmail: true,
        showWA: true,
        showCall: true,
        isFromJupiter: false,
    };
    const url = await SharedPropsService.getURL();
    const showEmail = await SharedPropsService.getShowEmail();
    const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
    let showWA = await SharedPropsService.getShowWA();
    if (isFromJupiter) {
        showWA = false;
    }
    const showCall = await SharedPropsService.getShowCall();
    const waData = await SharedPropsService.getWAData();
    const callData = await SharedPropsService.getCallData();
    const emailData = await SharedPropsService.getEmailData();
    const showSupportNUmberForPartnerCustomer = await showSupportNUmberForPartner();
    const whatsappDeepLinkDesktop = await getContactNumberForWhatsapp(url);
    const callDeepLink = await getContactNumberForCall(url);
    const emailId = 'support@voltmoney.in';
    const isFromPhonePe = await SharedPropsService.getAppPlatform() === "PHONEPE" /* AppPlatform.PHONEPE */;
    const showSupportPhoneNumber = await SharedPropsService.getSupportPhoneNumber();
    res.whatsappNumber = waData ? waData : whatsappDeepLinkDesktop;
    res.callNumber = callData ? callData : callDeepLink;
    res.email = emailData ? emailData : emailId,
        res.isFromPhonePe = isFromPhonePe;
    res.showSupportPhoneNumber = showSupportPhoneNumber || showSupportNUmberForPartnerCustomer;
    res.showEmail = showEmail;
    res.showCall = showCall;
    res.showWA = showWA;
    return res;
};
export const truncateToThreeDecimals = (num) => {
    const numStr = num?.toString();
    const decimalIndex = numStr?.indexOf('.');
    if (decimalIndex === -1 || numStr?.length - decimalIndex - 1 <= 3) {
        return num;
    }
    const truncatedStr = numStr?.substring(0, decimalIndex + 4);
    return truncatedStr;
};
export const uploadImageViaFetch = async () => {
    const config = await sharedPropsService?.getFirebaseConfig();
    const uploadViaFetch = config?.upload_image_via_fetch;
    if (uploadViaFetch &&
        (uploadViaFetch === true ||
            uploadViaFetch === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const showInterestCalculatorFlag = async () => {
    const show_interest_calculator_feature = await SharedPropsService.getFirebaseConfig().show_interest_calculator_feature;
    if (show_interest_calculator_feature === false ||
        //@ts-ignore
        show_interest_calculator_feature === 'false') {
        return false;
    }
};
export const getCookieValue = (name, popup) => {
    const cookies = popup ? popup?.document.cookie.split('; ') : document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
        const cookiePair = cookies[i].split('=');
        if (cookiePair[0] === name) {
            return cookiePair[1];
        }
    }
    return null;
};
export const getRepaymentExpectedDateBy = (epoch) => {
    const date = moment(epoch);
    const day = date.date();
    let suffix;
    if (day > 3 && day < 21) {
        suffix = 'th';
    }
    else {
        switch (day % 10) {
            case 1:
                suffix = "st";
                break;
            case 2:
                suffix = "nd";
                break;
            case 3:
                suffix = "rd";
                break;
            default: suffix = "th";
        }
    }
    const formattedDate = date.format("D") + suffix + " " + date.format("MMMM");
    return formattedDate;
};
export const fetchActiveIndex = (indexTab) => {
    if (indexTab === 'payout')
        return 1;
    else if (indexTab === 'login')
        return 2;
    else
        return 0;
};
export const showNewDashboardFlow = async (user) => {
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_customer_dashboard = await sharedPropsService.getFirebaseConfig()?.show_new_customer_dashboard_test_number;
    if (test_numbers_customer_dashboard === undefined || test_numbers_customer_dashboard === null) {
        return false;
    }
    const test_numbers_customer_dashboard_obj = JSON.parse(test_numbers_customer_dashboard);
    const show_test_numbers_customer_dashboard_phoneNumbers = test_numbers_customer_dashboard_obj?.numbers
        ? test_numbers_customer_dashboard_obj?.numbers
        : [];
    const showNewCustomerCard = await SharedPropsService.getFirebaseConfig()?.show_new_customer_dashboard;
    if (showNewCustomerCard &&
        (showNewCustomerCard === true ||
            showNewCustomerCard === "true")) {
        return true;
    }
    else {
        return show_test_numbers_customer_dashboard_phoneNumbers?.includes(userPhoneNumber.slice(3));
    }
};
export function getMonthNumber(monthName) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return monthNames.indexOf(monthName) + 1;
}
export function convertDateString(dateString) {
    const [dayWithSuffix, monthName, year] = dateString?.replace(',', '')?.split(' ');
    const day = dayWithSuffix?.replace(/(st|nd|rd|th)/, '');
    const month = getMonthNumber(monthName);
    const paddedDay = day?.padStart(2, '0');
    const paddedMonth = month?.toString()?.padStart(2, '0');
    const formattedDate = `${paddedDay}-${paddedMonth}-${year}`;
    return formattedDate;
}
export const decryptRes = (text) => {
    const textData = JSON.parse(text);
    if (!text) {
        return '';
    }
    text = textData.result.replace('-', '+').replace('_', '/');
    const decodedText = CryptoJS.enc.Base64.parse(text);
    const ivMaterial = 'globalaesvectors';
    const keyMaterial = 'G-KaPdSgVkYp3s5v8y/B?E(H+MbQeThW';
    const key = CryptoJS.enc.Utf8.parse(keyMaterial);
    const iv = CryptoJS.enc.Utf8.parse(ivMaterial);
    const ciphertext1 = CryptoJS.AES.decrypt({
        ciphertext: decodedText,
    }, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
    }); // default values: CBC, PKCS#7 padding
    const result = CryptoJS.enc.Utf8.stringify(ciphertext1);
    return result;
};
export const generateUniqueId = (length = 6) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let uniqueId = '';
    for (let i = 0; i < length; i++) {
        uniqueId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return uniqueId;
};
export const showNewInterestFlow = async () => {
    const showNewInterestCard = await SharedPropsService.getFirebaseConfig()?.show_NewVerify_AndInterest_Flow;
    if (showNewInterestCard &&
        (showNewInterestCard === true ||
            showNewInterestCard === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const showNewPendingCustomer = async (user) => {
    const userPhoneNumber = user?.user?.phoneNumber;
    const testNumbersPendingCustomer = await sharedPropsService.getFirebaseConfig()?.show_new_pending_customer_test_numbers;
    const showNewPendingCustomer = await SharedPropsService.getFirebaseConfig()?.show_new_pending_customer;
    if (showNewPendingCustomer &&
        (showNewPendingCustomer === true ||
            showNewPendingCustomer === "true")) {
        return true;
    }
    if (!testNumbersPendingCustomer) {
        return false;
    }
    const test_numbers_pendingCustomer_object = JSON.parse(testNumbersPendingCustomer);
    const show_pendingCustomer_test_phoneNumbers = test_numbers_pendingCustomer_object?.numbers
        ? test_numbers_pendingCustomer_object?.numbers
        : [];
    return show_pendingCustomer_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
};
export const showWithdrawRejectedCard = async (user) => {
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_withdrawal_rejection = await sharedPropsService.getFirebaseConfig()?.withdrawal_queries_test_numbers;
    if (test_numbers_withdrawal_rejection === undefined || test_numbers_withdrawal_rejection === null) {
        return false;
    }
    const test_numbers_withdrawal_rejection_obj = JSON.parse(test_numbers_withdrawal_rejection);
    const test_numbers_withdrawal_rejection_obj_numbers = test_numbers_withdrawal_rejection_obj?.numbers
        ? test_numbers_withdrawal_rejection_obj?.numbers
        : [];
    const showNewCustomerCard = await SharedPropsService.getFirebaseConfig()?.withdrawal_rejection;
    if (showNewCustomerCard &&
        (showNewCustomerCard === true ||
            showNewCustomerCard === "true")) {
        return true;
    }
    else {
        return test_numbers_withdrawal_rejection_obj_numbers?.includes(userPhoneNumber?.slice(3));
    }
};
export const showRepaymentRejectedCard = async (user) => {
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_repayment_rejection = await sharedPropsService.getFirebaseConfig()?.repayment_rejection_test_numbers;
    if (test_numbers_repayment_rejection === undefined || test_numbers_repayment_rejection === null) {
        return false;
    }
    const test_numbers_repayment_rejection_obj = JSON.parse(test_numbers_repayment_rejection);
    const test_numbers_repayment_rejection_obj_numbers = test_numbers_repayment_rejection_obj?.numbers
        ? test_numbers_repayment_rejection_obj?.numbers
        : [];
    const showRepaymentRejection = await SharedPropsService.getFirebaseConfig()?.repayment_rejection;
    if (showRepaymentRejection &&
        (showRepaymentRejection === true ||
            showRepaymentRejection === "true")) {
        return true;
    }
    else {
        return test_numbers_repayment_rejection_obj_numbers?.includes(userPhoneNumber?.slice(3));
    }
};
export const showExcessAmountHandling = async (user) => {
    const userPhoneNumber = user?.user?.phoneNumber;
    const excessAmountHandlingTestNumbers = await sharedPropsService.getFirebaseConfig()?.excess_amount_handling_test_numbers;
    const showExcessAmountHandling = await SharedPropsService.getFirebaseConfig()?.excess_amount_handling;
    if (showExcessAmountHandling &&
        (showExcessAmountHandling === true ||
            showExcessAmountHandling === "true")) {
        return true;
    }
    if (!excessAmountHandlingTestNumbers) {
        return false;
    }
    const excess_amount_handling_test_numbers_object = JSON.parse(excessAmountHandlingTestNumbers);
    const excess_amount_handling_test_numbers = excess_amount_handling_test_numbers_object?.numbers
        ? excess_amount_handling_test_numbers_object?.numbers
        : [];
    return excess_amount_handling_test_numbers?.includes(userPhoneNumber.slice(3));
};
export const isFromTDLPlatform = () => {
    const url = Platform.OS === 'web' ? window.location.href : '';
    const params = getParameters(url);
    const platformCode = params?.platform || '';
    if (platformCode === "TATADIGITAL" /* AppPlatform.TDL */)
        return true;
    return false;
};
export var INTEREST_REPAYMENT_STATUS;
(function (INTEREST_REPAYMENT_STATUS) {
    INTEREST_REPAYMENT_STATUS["AWAITING_MANDATE_STATUS"] = "AWAITING_MANDATE_STATUS";
    INTEREST_REPAYMENT_STATUS["DUE"] = "DUE";
    INTEREST_REPAYMENT_STATUS["FAILED"] = "FAILED";
    INTEREST_REPAYMENT_STATUS["OVERDUE"] = "OVERDUE";
    INTEREST_REPAYMENT_STATUS["SETTLED"] = "SETTLED";
})(INTEREST_REPAYMENT_STATUS || (INTEREST_REPAYMENT_STATUS = {}));
export var DSP_PAYMENT_STATUS;
(function (DSP_PAYMENT_STATUS) {
    DSP_PAYMENT_STATUS["SUCCESS"] = "SUCCESS";
    DSP_PAYMENT_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
    DSP_PAYMENT_STATUS["FAILED"] = "FAILED";
    DSP_PAYMENT_STATUS["CANCELLED"] = "CANCELLED";
    DSP_PAYMENT_STATUS["EXEEDED"] = "EXEEDED";
})(DSP_PAYMENT_STATUS || (DSP_PAYMENT_STATUS = {}));
export const getRazorpayKey = () => {
    let key = '';
    const buildType = getBuildType();
    key = (buildType === BUILD_TYPE.BORROWER_PRODUCTION || buildType === BUILD_TYPE.PARTNER_PRODUCTION) ? 'rzp_live_nN5S5ZnatVKUFw' : 'rzp_test_E2TJNdTgbYHwxm';
    return key;
};
export const getPaymentMode = (paymentMode) => {
    if (paymentMode === 'UPI') {
        return "Upi";
    }
    else if (paymentMode === 'NETBANKING') {
        return "Net banking";
    }
    else if (paymentMode === 'CARD') {
        return 'Card';
    }
    else
        return paymentMode;
};
export var FORECLOSURE_HANDLING;
(function (FORECLOSURE_HANDLING) {
    FORECLOSURE_HANDLING["UNLIEN_IN_PROCESS"] = "UNLIEN_IN_PROCESS";
    FORECLOSURE_HANDLING["DISBURSAL_IN_PROCESS"] = "DISBURSAL_IN_PROCESS";
    FORECLOSURE_HANDLING["REPAYMENT_IN_PROCESS"] = "REPAYMENT_IN_PROCESS";
    FORECLOSURE_HANDLING["FORECLOSURE_BUSINESS_HOUR_CHECK"] = "FORECLOSURE_BUSINESS_HOUR_CHECK";
    FORECLOSURE_HANDLING["FORECLOSURE_NOT_ALLOWED_LOAN_EXPIRED"] = "FORECLOSURE_NOT_ALLOWED_LOAN_EXPIRED";
    FORECLOSURE_HANDLING["FORECLOSURE_NOT_ALLOWED_RENEWAL_IN_PROGRESS"] = "FORECLOSURE_NOT_ALLOWED_RENEWAL_IN_PROGRESS";
    FORECLOSURE_HANDLING["FORECLOSURE_NOT_ALLOWED_FROM_LENDER"] = "FORECLOSURE_NOT_ALLOWED_FROM_LENDER";
    FORECLOSURE_HANDLING["BAD_REQUEST_POLICY_VIOLATION"] = "BAD_REQUEST_POLICY_VIOLATION";
})(FORECLOSURE_HANDLING || (FORECLOSURE_HANDLING = {}));
export const handlePayment = async (user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute) => {
    let routeId = 'proceedButton';
    if (redirectingRoute === ROUTE.OUTSTANDING_DUES) {
        routeId = 'manageLimit';
    }
    const options = {
        description: '',
        image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Favicon.png",
        currency: "INR",
        key: key,
        amount: `${amount * 100}`,
        name: "DSP Finance Pvt Ltd",
        order_id: currentOrderId,
        prefill: {
            name: `${user?.user?.fullName}`,
            email: `${user?.linkedBorrowerAccounts[0]?.accountHolderEmail}`,
            contact: `${user?.user?.phoneNumber}`,
        },
        method: {
            netbanking: preferredMethod.includes('netbanking'),
            upi: preferredMethod.includes('upi'),
            card: preferredMethod.includes('card'),
            wallet: false,
            emi: false,
            paylater: false,
        },
        theme: {
            color: color,
        },
        timeout: timeout,
        retry: {
            enabled: true,
            max_count: 4,
        },
        send_sms_hash: true,
        card: {
            types: ['RUPAY',]
        },
        modal: {
            remember_customer: true,
            ondismiss: function () {
                setDatastore(redirectingRoute, routeId, {
                    loading: false
                });
                navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId, dspPaymentStatus: DSP_PAYMENT_STATUS.CANCELLED, currentOrderId, redirectingRoute });
            }
        }
    };
    try {
        const data = await RazorpayCheckout.open(options);
        navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId });
    }
    catch (error) {
        navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId, dspPaymentStatus: DSP_PAYMENT_STATUS.CANCELLED, currentOrderId, redirectingRoute });
    }
};
const loadRazorpayScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};
let paymentFailed = false;
export const handleWebPayment = async (user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute) => {
    const res = await loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js');
    let routeId = 'proceedButton';
    if (redirectingRoute === ROUTE.OUTSTANDING_DUES) {
        routeId = 'manageLimit';
    }
    if (!res) {
        setDatastore(redirectingRoute, routeId, {
            loading: false
        });
        return;
    }
    const options = {
        description: '',
        image: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Favicon.png",
        currency: "INR",
        key: key,
        amount: `${amount * 100}`,
        name: "DSP Finance Pvt Ltd",
        order_id: currentOrderId,
        prefill: {
            name: `${user?.user?.fullName}`,
            email: `${user?.linkedBorrowerAccounts[0]?.accountHolderEmail}`,
            contact: `${user?.user?.phoneNumber}`,
        },
        method: {
            upi: true,
        },
        retry: {
            enabled: true,
            max_count: 4,
        },
        card: {
            name: "Pay Via Cards",
            instruments: [
                {
                    method: "card",
                    networks: ["RuPay"],
                    types: ["debit"]
                }
            ]
        },
        timeout: timeout,
        save: 1,
        // remember_customer: true,
        config: {
            display: {
                blocks: {
                    netbanking: {
                        name: "Netbanking",
                        instruments: preferredMethod.includes('netbanking') ? [{ method: "netbanking" }] : []
                    },
                    card: {
                        name: "Cards",
                        instruments: preferredMethod.includes('card') ? [{ method: "card" }] : []
                    },
                    upi: {
                        name: "UPI",
                        instruments: preferredMethod.includes('upi') ? [{ method: "upi" }] : []
                    }
                },
                sequence: ['block.upi', 'block.netbanking', 'block.card',],
                preferences: {
                    show_default_blocks: false
                }
            }
        },
        theme: {
            color: color,
        },
        modal: {
            escape: false,
            handleback: false,
            backdropclose: false,
            remember_customer: true,
            ondismiss: function () {
                setDatastore(redirectingRoute, routeId, {
                    loading: false
                });
                navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId, dspPaymentStatus: DSP_PAYMENT_STATUS.CANCELLED, currentOrderId, redirectingRoute });
            }
        },
        handler: (response) => {
            setDatastore(redirectingRoute, routeId, {
                loading: false
            });
            navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId });
        },
    };
    //@ts-ignore
    const rzp = new Razorpay(options);
    rzp.on('payment.failed', (response) => {
        if (!paymentFailed) {
            paymentFailed = true;
            setDatastore(redirectingRoute, routeId, {
                loading: false
            });
            navigateToBase(ROUTE.PAYMENT_CALLBACK, { collectionId: collectionId, dspPaymentStatus: DSP_PAYMENT_STATUS.FAILED, currentOrderId, redirectingRoute });
        }
    });
    rzp.open();
};
export const RAZOR_PAY_PREFERRED_METHOD = {
    LESS_THAN_2K: ['upi', 'card'],
    LESS_THAN_100K: ['upi', 'netbanking', 'card',],
    DEFAULT: ['netbanking', 'card'],
};
export var ELIGIBLE_LIMIT;
(function (ELIGIBLE_LIMIT) {
    ELIGIBLE_LIMIT[ELIGIBLE_LIMIT["MIN_LIMIT"] = 25000] = "MIN_LIMIT";
    ELIGIBLE_LIMIT[ELIGIBLE_LIMIT["MAX_AMOUNT"] = 50000] = "MAX_AMOUNT";
})(ELIGIBLE_LIMIT || (ELIGIBLE_LIMIT = {}));
export const showSupportNumberForAllCustomer = async (user = undefined) => {
    if (user === undefined) {
        user = await sharedPropsService.getUser();
    }
    const userPhoneNumber = user?.user?.phoneNumber;
    const showSupportNumber = await SharedPropsService.getFirebaseConfig()?.show_support_number_for_all_customer;
    const showSupportTestNumber = await SharedPropsService.getFirebaseConfig()?.show_support_number_for_all_customer_test_numbers;
    const test_numbers_support_obj = JSON.parse(showSupportTestNumber);
    const test_numbers_support_obj_numbers = test_numbers_support_obj?.numbers
        ? test_numbers_support_obj?.numbers
        : [];
    if (showSupportNumber &&
        (showSupportNumber === true ||
            showSupportNumber === "true")) {
        if (!test_numbers_support_obj_numbers?.includes(userPhoneNumber.slice(3))) {
            return true;
        }
        else
            return false;
    }
    else {
        return false;
    }
};
export var ACCEPTABLE_MAX_CREDIT;
(function (ACCEPTABLE_MAX_CREDIT) {
    ACCEPTABLE_MAX_CREDIT[ACCEPTABLE_MAX_CREDIT["MAX_AMOUNT"] = 20000000] = "MAX_AMOUNT";
})(ACCEPTABLE_MAX_CREDIT || (ACCEPTABLE_MAX_CREDIT = {}));
export const showDspContent = async () => {
    const showDspContentForAll = await SharedPropsService.getFirebaseConfig()?.show_dsp_content;
    if (showDspContentForAll &&
        (showDspContentForAll === true ||
            showDspContentForAll === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const showNewCongratsScreen = async () => {
    const showNewCongratsScreen = await SharedPropsService.getFirebaseConfig()?.show_new_congrats_screen;
    if (showNewCongratsScreen &&
        (showNewCongratsScreen === true ||
            showNewCongratsScreen === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const convertISODate = (timeString) => {
    // timeString = "2023-02-28T10:30:52.119Z";
    const dateObj = new Date(timeString);
    const date = dateObj.toLocaleDateString('en-US', { day: 'numeric' });
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const year = dateObj.toLocaleDateString('en-US', { year: 'numeric' });
    return { date, month, year };
};
export const returnDateInString = (epochDate) => {
    const { date, month, year } = convertISODate(epochDate);
    let suffix = 'th';
    if (date === "1" || date === "21" || date === "31") {
        suffix = 'st';
    }
    else if (date === "2" || date === "22") {
        suffix = 'nd';
    }
    else if (date === "3" || date === "23") {
        suffix = 'rd';
    }
    return `${date}${suffix} ${month.slice(0, 3)}, ${year}`;
};
export const showUnpledgeOptMessage = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const testNumbers = await sharedPropsService.getFirebaseConfig()?.show_withdraw_opt_message_test_numbers;
    const showWithdrawOptMessage = await SharedPropsService.getFirebaseConfig()?.show_withdraw_opt_message;
    if (showWithdrawOptMessage &&
        (showWithdrawOptMessage === true ||
            showWithdrawOptMessage === "true")) {
        return true;
    }
    if (!testNumbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(testNumbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    return show_test_phoneNumbers?.includes(userPhoneNumber.slice(3));
};
export const allowDynamicLimitFromBE = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const testNumbers = await sharedPropsService.getFirebaseConfig()?.dynamicLimitTestNumber;
    const dynamicCheckLimitFromBE = await SharedPropsService.getFirebaseConfig()?.dynamicCheckLimitFromBE;
    if (dynamicCheckLimitFromBE &&
        (dynamicCheckLimitFromBE === true ||
            dynamicCheckLimitFromBE === "true")) {
        return true;
    }
    if (!testNumbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(testNumbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    return show_test_phoneNumbers?.includes(userPhoneNumber?.slice(3));
};
export const mfdShareLinkFeatureFlag = async () => {
    const data = await AsyncStorage.getItem(StoreKey.userContext);
    const _user = data && JSON.parse(data);
    const userPhoneNumber = _user?.linkedPartnerAccounts[0]?.accountHolderPhoneNumber;
    const testNumbers = await sharedPropsService.getFirebaseConfig()?.enable_mfd_link_share_test_numbers;
    const dynamicCheckLimitFromBE = await SharedPropsService.getFirebaseConfig()?.enable_mfd_link_share;
    if (dynamicCheckLimitFromBE &&
        (dynamicCheckLimitFromBE === true ||
            dynamicCheckLimitFromBE === "true")) {
        return true;
    }
    if (!testNumbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(testNumbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    return show_test_phoneNumbers?.includes(userPhoneNumber?.slice(3));
};
export const isARNRequiredFlag = async () => {
    const isARNRequired = await SharedPropsService.getFirebaseConfig()?.isARNRequired;
    if (isARNRequired && (isARNRequired === true || isARNRequired === "true")) {
        return true;
    }
    return false;
};
export const MfCentralFlow = "MfCentralFlow";
export var CREDIT_STATUS;
(function (CREDIT_STATUS) {
    CREDIT_STATUS["PENDING_DISBURSAL_APPROVAL"] = "PENDING_DISBURSAL_APPROVAL";
    CREDIT_STATUS["PENDING_LODGEMENT"] = "PENDING_LODGEMENT";
    CREDIT_STATUS["APPROVED_NOT_DISBURSED"] = "APPROVED_NOT_DISBURSED";
    CREDIT_STATUS["ACTIVE"] = "ACTIVE";
    CREDIT_STATUS["PENDING_CLOSURE"] = "PENDING_CLOSURE";
    CREDIT_STATUS["CLOSED"] = "CLOSED";
})(CREDIT_STATUS || (CREDIT_STATUS = {}));
export const showUserLoanDetils = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const testNumbers = await sharedPropsService.getFirebaseConfig()?.showLoanDetailsTestNumbers;
    const showLoanDetails = await SharedPropsService.getFirebaseConfig()?.showLoanDetails;
    if (showLoanDetails &&
        (showLoanDetails === true ||
            showLoanDetails === "true")) {
        return true;
    }
    if (!testNumbers) {
        return false;
    }
    const test_numbers_object = JSON.parse(testNumbers);
    const show_test_phoneNumbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    return show_test_phoneNumbers?.includes(userPhoneNumber?.slice(3));
};
export const showUserEditDetailsIcon = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const test_number_user_updates = await sharedPropsService.getFirebaseConfig()?.show_details_update_test_numbers;
    if (!test_number_user_updates)
        return false;
    const test_numbers_object = JSON.parse(test_number_user_updates);
    const test_numbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const showDetailsUpdateTata = await sharedPropsService.getFirebaseConfig()?.show_details_update_tata;
    const showDetailsUpdateBajaj = await sharedPropsService.getFirebaseConfig()?.show_details_update_bajaj;
    const showDetailsUpdateDsp = await sharedPropsService.getFirebaseConfig()?.show_details_update_dsp;
    if (lenderId?.toLowerCase() === LENDER_ID.TATA) {
        if (showDetailsUpdateTata &&
            (showDetailsUpdateTata === true ||
                showDetailsUpdateTata === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else if (lenderId?.toLowerCase() === LENDER_ID.BAJAJ) {
        if (showDetailsUpdateBajaj &&
            (showDetailsUpdateBajaj === true ||
                showDetailsUpdateBajaj === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else {
        if (showDetailsUpdateDsp &&
            (showDetailsUpdateDsp === true ||
                showDetailsUpdateDsp === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
};
export const showNewRepaymentFlowDc = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const test_number_repayments = await sharedPropsService.getFirebaseConfig()?.show_newRepayment_test_numbers;
    if (!test_number_repayments)
        return false;
    const test_numbers_object = JSON.parse(test_number_repayments);
    const test_numbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const showRepaymentTata = await sharedPropsService.getFirebaseConfig()?.show_newRepayment_tata;
    const showRepaymentBajaj = await sharedPropsService.getFirebaseConfig()?.show_newRepayment_bajaj;
    const showRepaymentDsp = await sharedPropsService.getFirebaseConfig()?.show_newRepayment_dsp;
    if (lenderId?.toLowerCase() === LENDER_ID.TATA) {
        if (showRepaymentTata &&
            (showRepaymentTata === true ||
                showRepaymentTata === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else if (lenderId?.toLowerCase() === LENDER_ID.BAJAJ) {
        if (showRepaymentBajaj &&
            (showRepaymentBajaj === true ||
                showRepaymentBajaj === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else {
        if (showRepaymentDsp &&
            (showRepaymentDsp === true ||
                showRepaymentDsp === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
};
export const showDSPVirtualAccount = async () => {
    const showvirtualAccount = await SharedPropsService.getFirebaseConfig()?.show_virtualAccountDsp;
    if (showvirtualAccount &&
        (showvirtualAccount === true ||
            showvirtualAccount === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const showPhonePeSdk = async () => {
    const showSdk = await SharedPropsService.getFirebaseConfig()?.enable_phonePe_sdk;
    if (showSdk &&
        (showSdk === true ||
            showSdk === "true")) {
        return true;
    }
    else {
        return false;
    }
};
export const enableBFLPartner = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_number_repayments = await sharedPropsService.getFirebaseConfig()?.bfl_partner_repayment_test_numbers;
    if (!test_number_repayments)
        return false;
    const test_numbers_object = JSON.parse(test_number_repayments);
    const test_numbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const showBFLRepayment = await sharedPropsService.getFirebaseConfig()?.bfl_partner_repayment;
    if (showBFLRepayment &&
        (showBFLRepayment === true ||
            showBFLRepayment === "true")) {
        return true;
    }
    else {
        return test_numbers?.includes(userPhoneNumber?.slice(3));
    }
};
export const isFromMFDShareLinkJourney = () => {
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const sl_id = params[QUERY_PARAMS.SL];
    if (sl_id) {
        return true;
    }
    else {
        return false;
    }
};
export const isFromMFDShareLinkJourneyPartnerSide = () => {
    const params = Platform.OS === 'web' ? getParameters(window?.location?.href) : '';
    const context = params[QUERY_PARAMS.CONTEXT];
    if (context === 'PARTNER') {
        return true;
    }
    else {
        return false;
    }
};
export const showNewForeClosureFlow = async (user = undefined) => {
    if (user === undefined) {
        user = await sharedPropsService.getUser();
    }
    const userPhoneNumber = user?.user?.phoneNumber;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const test_number_foreclosure = await sharedPropsService.getFirebaseConfig()?.show_new_foreclosure_flow_test_numbers;
    if (!test_number_foreclosure)
        return false;
    const test_numbers_object = JSON.parse(test_number_foreclosure);
    const test_numbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const showNewForeclosureFlow = await sharedPropsService.getFirebaseConfig()?.show_new_foreclosure_flow;
    const showNewForeclosureFlowBajaj = await sharedPropsService.getFirebaseConfig()?.show_new_foreclosure_flow_bajaj;
    if (lenderId?.toLowerCase() === LENDER_ID.BAJAJ) {
        if (showNewForeclosureFlowBajaj &&
            (showNewForeclosureFlowBajaj === true ||
                showNewForeclosureFlowBajaj === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else {
        if (showNewForeclosureFlow &&
            (showNewForeclosureFlow === true ||
                showNewForeclosureFlow === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
};
export const getBiometricsPermissionFromFirebase = async () => {
    const biometrics_permission_staging = await sharedPropsService.getFirebaseConfig()?.enable_biometrics_staging;
    const biometrics_permission = await sharedPropsService.getFirebaseConfig()?.enable_biometric;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const biometricsPermissionStaging = biometrics_permission_staging === true || biometrics_permission_staging === "true";
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const biometricsPermission = biometrics_permission === true || biometrics_permission === "true";
    return getBuildType() !== BUILD_TYPE.BORROWER_PRODUCTION ? biometricsPermissionStaging : biometricsPermission;
};
export const showHelpAndSupportField = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const test_number_helpAndSupport = await sharedPropsService.getFirebaseConfig()?.show_help_and_support_test_numbers;
    if (!test_number_helpAndSupport)
        return false;
    const test_numbers_object = JSON.parse(test_number_helpAndSupport);
    const test_numbers = test_numbers_object?.numbers
        ? test_numbers_object?.numbers
        : [];
    const showHelpAndSupportField = await sharedPropsService.getFirebaseConfig()?.show_help_and_support;
    const showHelpAndSupportFieldBajaj = await sharedPropsService.getFirebaseConfig()?.show_help_and_support_bajaj;
    const creditStatus = user?.linkedCredits[0]?.creditStatus;
    if (creditStatus !== CREDIT_STATUS.ACTIVE)
        return false;
    if (lenderId?.toLowerCase() === LENDER_ID.BAJAJ) {
        if (showHelpAndSupportFieldBajaj &&
            (showHelpAndSupportFieldBajaj === true ||
                showHelpAndSupportFieldBajaj === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else {
        if (showHelpAndSupportField &&
            (showHelpAndSupportField === true ||
                showHelpAndSupportField === "true")) {
            return true;
        }
        else {
            return test_numbers?.includes(userPhoneNumber?.slice(3));
        }
    }
};
export const getFaqData = () => {
    const faqData = sharedPropsService.getFirebaseConfig()?.faqData;
    let parsedData = JSON.parse(faqData);
    return parsedData?.faqData;
};
